export default {
  title: {
    payErrorJump: '收银台'
  },
  msg: {
    title: '短信'
  },
  rate: {
    title: 'IDD收费表',
    searchNoResult: '无结果',
    searchTip: '搜索',
    tableTitleLeft: '国家 / 地区',
    tableTitleCenter: '区号',
    tableTitleRight: '收费',
    tableTitleRightUnit: '(HKD/分钟)',
    cancel: '取消',
    tipTitle: '温馨说明',
    tip1: '1. 以下收费以港币为单位；所有收费以每分钟计算，不足一分钟亦作一分钟计算。',
    tip2: '2. 香港号码长途电话服务需另外计算香港/中港通话分钟或香港/中港通话分钟收费。',
    tip3: '3. 广州博元讯息服务有限公司保留对以下优惠条款及细则之最终决定权。收费如有更改恕不另行通知。'
  },
  company: {
    title: '关于博元',
    ERCodeDesc: '博元讯息',
    info: '博元讯息（MB）集团是创立于 2000 年的一家电讯增值服务提供者，并在广州和香港均设置了分支机构，并获得了香港通讯事务管理局颁发的“流动虚拟网路营办商服务”牌照（牌照号码：1687）和中国人民共和国工业和信息化部颁发的“中华人民共和国增值电信业务经营许可证”（经营许可证编号：A1-20184242）。',
    gotoMB: '前往博元讯息网站'
  },
  privacyText: {
    title: '易博通eSender隐私政策',
    summary:
      {
        title: '摘要',
        text: '广州博元讯息服务有限公司。（“ eSender”或“我们”或“我们的”或“我们的”或其他类似代词）非常重视您的隐私问题。请阅读以下内容，以了解有关我们的隐私政策（“政策”）的更多信息。本政策详细说明了我们如何接收，收集和使用eSender软件上提供服务有关的信息。 （以上统称为“服务”）。使用本服务时，即表示您接受本政策中所述的政策和惯例，因为该政策可能会不时进行修改。每次您使用服务时，即表示您同意并明确同意我们按照本政策的规定收集，使用和披露您提供的信息。'
      },
    one: {
      title: '一.我们会收集阁下的哪些资讯？',
      text1: '若阁下设定易博通eSender  帐户，并使用易博通eSender提供的服务，我们将会收集阁下的资讯。我们会收集阁下的',
      text2: '设备型号、操作系统、位置信息、手机读写、麦克风、通讯录、摄像头、唯一设备标识符、登录IP地址、接入网络的方式、类型和状态、网络质量数据、操作日志、昵称、手机号码以及通话和短信记录',
      text3: '，这些信息是为提供服务必须收集的基础信息。同时阁下可以提供更多资讯，让阁下的个人资料更精细与受欢迎，所收集到的信息我们将妥善存储和谨慎使用。'
    },
    two: {
      title: '二.第三方SDK目录',
      substile1: '1) 极光(Jiguang)SDK，用于消息推送',
      text2: 'A.获取权限：',
      text3: '•获取您的设备信息',
      text4: '•获取您的读写外部存储',
      text5: '•查看您的网络链接状态 ',
      text6: 'B.使用目的',
      text7: '•推送消息',
      text8: 'C.处理方式',
      text9: '•采用替换，去标识，加密，匿名化方式对个人信息进行脱敏展示',
      text10: 'D.极光隐私协议',
      subtitle2: '2)友盟UShare SDK',
      text20: '为了向阁下提供一键分享服务，我们的产品集成友盟+ Ushare SDK，友盟Ushare SDK需要收集阁下的 设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息）以及阁下需要分享的社交账号公开信息，以便完成一键分享服务。并通过地理位置校准报表数据准确性，提供基础反作弊服务。为了阁下的信息安全，我们已与第三方SDK服务商进行数据安全保密约定，这些公司会严格遵守我们的数据隐私和安全要求。\n' +
        '        除非得到阁下的同意，我们不会与其共享阁下的个人身份信息。为便于阁下更好地了解【友盟+】采集的数据类型及用途，以及何保护阁下的个人信息.',
      text21: '阁下可以访问',
      text22: '了解【友盟+】隐私权政策 .',
      subtitle3: '3) 腾讯Bugly SDK',
      text30: '为了更好排查崩溃问题,帮助APP提升稳定性，我们的产品集成了腾讯Bugly SDK，腾讯Bugly SDK需要收集Android系统版本，厂商系统版本，内存空间占用大小等信息，为了阁下的信息安全，我们已与第三方SDK服务商进行数据安全保密约定，这些公司会严格遵守我们的数据隐私和安全要求。 除非得到阁下的同意，我们不会与其共享阁下的个人身份信息。为便于阁下更好地了解【Bugly SDK】采集的数据类型及用途，以及何保护阁下的个人信息.',
      text31: '阁下可以访问 ',
      text32: ', 了解Bugly SDK隐私保护声明.'
    },
    three: {
      title: '三.我们会如何使用阁下的资讯？',
      text1: '我们会使用阁下的资讯来提供阁下的易博通eSender服务，允许阁下与其他使用者通讯，以及使用易博通eSender公开平台的功能。我们会使用阁下的资讯来设定帐户、促进通讯、提供支援、允许阁下存取易博通eSender功能，并改善易博通eSender服务。易博通eSender会使用阁下所使用的WeChat应用，以验证及保护阁下的帐户，也会为重要管理因素而使用，且易博通eSender不会将这些联络管道用于推销或行销。'
    },
    four: {
      title: '四.我们会与谁分享阁下的资料？',
      text1: '我们会使用第三方支援服务，例如使用WeChat公共平台来提供帐户验证服务。我们使用这些第三方服务来处理或储存阁下的资讯时，会以本政策所载的目的为限。我们也会和博元相关集团公司共用阁下的资讯，并根据法律要求来共用。除以上所列之目的外，若无阁下的事前明文同意，易博通eSender不会与第三方共用阁下的资料。任何我们与之分享用户资讯的第三方服务商（由我们所拣选），都会提供与本政策所述相同，或者同等级的用户资讯保护标准。'
    },
    five: {
      title: '五.我们保留阁下资料的时间会持续多久？',
      text1: '我们保留阁下资讯的时间会依据资讯类型而定，例如登入资料会保留长达 90 天，自收集资料之日起算。'
    },
    six: {
      title: '六.我要如何行使我对资料的权利？',
      text1: '阁下对阁下的资料及我们使用阁下资料的方式有特殊权利。这些权利包含阁下存取资料的方式、消除资料的方式、限制使用阁下资料的方式、拒绝使用资料，以及取得阁下的资讯副本。'
    },
    seven: {
      title: '七.争议解决',
      text1: '如阁下有任何疑虑或投诉事项，请联络我们：',
      text2: '香港 +852  2156 6888',
      text3: '中国 400  888 4333'
    },
    eight: {
      title: '八.我们如何向阁下通知变更？',
      text1: ' 若本隐私政策有任何重大变更，在变更生效前，我们会传送通知给阁下。',
      text2: '我们重视阁下的隐私。本隐私政策旨在告知阁下，对于阁下向我们提供的任何资讯，或阁下因使用易博通eSender而产生之资讯，阁下可以做出的选择以及我们的惯例。',
      text3: '使用我们的服务（例如易博通eSender行动应用程式、博元公司网站  www.multi-byte.com 或提供易博通eSender服务之任何第三方平台）（合称为“易博通eSender”）包含处理阁下的资讯之行为。阁下有必要了解对阁下资讯的收集与使用过程，以及阁下可以如何对其进行管理，这些都是很重要的资讯。请详阅此隐私政策。'
    },
    nice: {
      title: '九.联络我们',
      text1: '如阁下有任何疑虑或投诉事项，请联络我们：',
      text2: '香港 +852  2156 6888',
      text3: '中国 400  888 4333'
    },
    update: {
      text1: '广州博元讯息服务有限公司-最后修订'
    }
  },
  regulation: {
    title: '服务条款',
    clause: {
      clauseTitle1: ' “易博通”服务计划同意书 (香港号码)',
      clause1: ' 1、以上服务提供于微信“易博通eSender”公众号绑定香港号码查阅及发送短讯服务。博元讯息科技有限公司(“博元”)亦可提供实体智能卡予客户携号转台或使用话音﹑数据及手机发送短讯服务，唯客户需要缴付智能卡费用及／或速递费用（如适用）。话音﹑数据及手机发送短服务需另行收费。',
      clause2: ' 2、于微信发送短讯只提供予已选用套餐的户口，并需另行收费，费用会于户口内余额扣除，有关收费详情请浏览博元网页www.multi-byte.com或本公众号',
      clause3: ' 3、当服务有效期届满前，博元将发送讯息予客户登记之香港号码提示客户，客户可于已于绑定香港号码的微信“易博通eSender”公众号查阅，并可于效期届满前自行于本公众号或博元网页www.multi-byte.com缴费以延长服务有效期',
      clause4: ' 4、当服务有效期完结时，服务会被暂停。客户可于微信或博元网页缴费并重启服务。暂停期间之讯息将不获补发',
      clause5: ' 5、如服务因任何原故而停用超过7日或终止服务，客户同意届时必须放弃该分配的香港号码并归还予博元',
      clause6: ' 6、服务计划中的香港号码不能更改',
      clause7: ' 7、如服务因任何原故而停用，所预缴之费用将不获退还',
      clause8: ' 8、任何优惠不得自由转让、退回现金及/ 或不可兑换其他服务及/ 或产品。',
      clause9: ' 9、此服务受博元讯息科技有限公司的《一般条款及条件》约束，详情请浏览博元网页',
      clause10: ' 10、上述资料为阁下自愿提供，如有资料错漏，博元讯息可能未能为阁下提供所申请之服务，博元讯息有权使用上述资料为阁下提供服务，通知阁下优惠推广活动，如有需要，披露予第三方作信用覆核﹑追讨债务﹑市场研究﹑及在法律规定下或遵从被认可之政府机关要求下披露及经阁下同意使用之其他用途',
      clause11: ' 11、博元讯息科技有限公司保留更改本服务计划同意书之条款及条件与优惠之权利，恕不另行通知，遇有任何争议，概以博元之决定为最终决定，客户须受彼等约束',
      clauseTitle2: ' “易博通”服务计划同意书 (香港号码-携号转台服务)',
      clause12: ' 12、以上服务提供于微信“易博通eSender”公众号绑定香港号码查阅及发送短讯服务。博元讯息科技有限公司(“博元”)亦可提供实体智能卡予客户携号转台或使用话音﹑数据及手机发送短讯服务，唯客户需要缴付智能卡费用及／或速递费用（如适用）。话音﹑数据及手机发送短服务需另行收费',
      clause13: ' 13、于微信发送短讯只提供予已选用套餐的户口，并需另行收费，费用会于户口内余额扣除，有关收费详情请浏览博元网页www.multi-byte.com或本公众号',
      clause14: ' 14、当服务有效期届满前，博元将发送讯息予客户登记之香港号码提示客户，客户可于已于绑定香港号码的微信 “易博通eSender”公众号查阅，并可于效期届满前自行于本公众号或博元网页www.multi-byte.com缴费以延长服务有效期',
      clause15: ' 15、当服务有效期完结时，服务会被暂停。客户可于微信或博元网页缴费并重启服务。暂停期间之讯息将不获补发',
      clause16: ' 16、如服务因任何原故而停用超过7日或终止服务，客户同意届时必须放弃该分配的香港号码并归还予博元',
      clause17: ' 17、服务计划中的香港号码不能更改',
      clause18: ' 18、如服务因任何原故而停用，所预缴之费用将不获退还',
      clause19: ' 19、任何优惠不得自由转让、退回现金及/ 或不可兑换其他服务及/ 或产品',
      clause20: ' 20、本人明白有关流动号码的转携并不影响有关流动号码成功转携前本人在供号网络营办商适用的服务条款与细则下对供号网络营办商的责任',
      clause22: ' 21、生效时间受供号网络营办商确认上述资料及供号网络营办商与博元之间按电讯管理局局长所发出的与实施流动电话号码可携性有关的实务守则技术安排的限制。博元获明示授权更改博元讯息合理地认为合适的生效时间',
      clause23: ' 22、有关流动号码若由于本人未有提供完整的资料，或提供错误或失实的资料或因博元讯息未能合理控制的任何理由，而导致流动电话号码无法携带至博元的网络，博元有权取消本转携申请',
      clause24: ' 23、除任何无法卸除的法律责任外，本人同意因本申请和相关号码转携安排引致或造成本人或其他任何人士蒙受损失或损害，博元无需对本人或任何其他人士负上法律责任 (不论是在合约、侵权或其他方面)。 ',
      clause25: ' 24、此服务受博元讯息科技有限公司的《一般条款及条件》约束，详情请浏览博元网页',
      clause26: ' 25、上述资料为阁下自愿提供，如有资料错漏，博元讯息可能未能为阁下提供所申请之服务，博元讯息有权使用上述资料为阁下提供服务，通知阁下优惠推广活动，如有需要，披露予第三方作信用覆核﹑追讨债务﹑市场研究﹑及在法律规定下或遵从被认可之政府机关要求下披露及经阁下同意使用之其他用途',
      clause27: ' 26、博元讯息科技有限公司保留更改本服务计划同意书之条款及条件与优惠之权利，恕不另行通知，遇有任何争议，概以博元之决定为最终决定，客户须受彼等约束',
      clauseTitle3: ' “易博通”服务计划同意书 (中国内地号码)',
      clause28: ' 27、以上服务不提供实体智能卡',
      clause29: ' 28、以上服务只提供于“易博通eSender”微信公众号绑定中国内地号码查阅及发送短讯服务，现阶段并不包括话音或数据服务。发送短讯只提供予已选用套餐的户口，并需另行收费，费用会于户口内余额扣除，有关收费详情请浏览博元网页www.multi-byte.com',
      clause30: ' 29、当服务有效期届满前，博元讯息科技有限公司(“博元”)将发送讯息予客户登记之中国内地号码提示客户，客户可于已于绑定中国内地号码的“ 易博通eSender”微信公众号查阅，并可于效期届满前自行于微信或博元网页www.multi-byte.com缴费以延长服务有效期',
      clause31: ' 30、当服务有效期完结时，服务会被暂停。客户可于微信或博元网页缴费并重启服务。暂停期间之讯息将不获补发',
      clause32: ' 31、如服务因任何原故而停用超过30日或终止服务，客户同意届时必须放弃该分配的中国内地号码并归还予博元',
      clause33: ' 32、服务计划中的中国内地号码不能更改',
      clause34: ' 33、服务计划中的中国内地号码祇适用于“易博通”服务',
      clause35: ' 34、如服务因任何原故而停用，所预缴之费用将不获退还',
      clause36: ' 35、任何优惠不得自由转让、退回现金及/ 或不可兑换其他服务及/ 或产品',
      clause37: ' 36、中华人民共和国工业和信息部文件《电话用户真实身份信息登记实施规范》，申请中国内地流动电话号码必须实名登记，实名登记的年龄范围必须在16岁以上。博元须向阁下搜集阁下的个人资料，包括姓名、流动电话号码、联络方法﹑港澳身份证﹑台湾居民来往大陆通行证、中国公民身份证、护照或其它身份证明文件﹑免冠相片及自拍影片的资料等(“上述资料”)，以协助阁下向中国内地当局办理实名登记(“上述登记”)。上述资料会按中国内地政府推行的流动电话号码实名登记政策有所更改。阁下没有义务向博元提供上述资料，但如阁下不提供个人资料，中国内地当局会按相关政策指令停止阁下的中国内地号码服务，阁下将无法开通使用或继续使用涉及中国内地流动电话号码的电讯通讯服务，详情请浏览博元网页www.multi-byte.com',
      clause38: ' 37、用户如有虚假交易的行为﹑以转售或诈骗为目的使用本服务，博元有权在无任何补偿或事先通知情况下，终止阁下的中国内地号码服务',
      clause39: ' 38、用户不得将易博通服务用于电信资讯网路诈骗及其他违法行为，如出现电话诈骗、网路诈骗、垃圾短信投诉情况，博元有权在无任何补偿或事先通知情况下，永久终止阁下的易博通号码。',
      clause40: ' 39、此服务受博元讯息科技有限公司的《一般条款及条件》约束，详情请浏览博元网页www.multi-byte.com',
      clause41: ' 40、上述资料为阁下自愿提供，如有资料错漏，博元讯息可能未能为阁下提供所申请之服务，博元讯息有权使用上述资料为阁下提供服务，通知阁下优惠推广活动，如有需要，披露予第三方作信用覆核﹑追讨债务﹑市场研究﹑及在法律规定下或遵从被认可之政府机关要求下披露及经阁下同意使用之其他用途',
      clause42: ' 41、博元讯息科技有限公司保留更改本服务计划同意书之条款及条件与优惠之权利，恕不另行通知，遇有任何争议，概以博元之决定为最终决定，客户须受彼等约束',
      clauseEnd: ' 本人/本公司已细阅及明白本附加协议之条款/及条件，并同意受彼等约束。'
    }
  },
  charge: {
    title: '产品收费表',
    select: {
      option1: '所有套餐',
      option2: '中国香港号码套餐',
      option3: '中国内地号码套餐'
    },
    price: '价钱',
    dayNum: '日数',
    receiveMsg: '接收短讯',
    data: '流动数据',
    limitless: '无限',
    service: '服务',
    phoneTime: '通话分钟',
    phoneTimeAndData: '通话分钟、流动数据',
    notAvailable: '不适用',
    day: '天',
    minute: '分钟',
    hk: '(香港)',
    mo: '(澳门)',
    cn_mo: '(中国及澳门)',
    hkTableTitle: '香港号码套餐',
    package: {
      p1: '微信收短信 （免SIM卡套餐）',
      p2: '实体 SIM 卡 / eSIM 套餐',
      p3: 'eSIM 套餐',
      p4: '实体 SIM 卡 / eSIM 套餐'
    },
    tips: {
      t1: '(只适用于香港地区)',
      t2: '( 适用于中国香港 )',
      t3: '(只适用于香港及澳门地区)',
      t4: '( 适用于中国香港及澳门 )',
      t5: '( 适用于中国香港及澳门 )',
      t6: '( 适用于中国内地、香港、澳门、台湾 )',
      t7: '( 适用于中国内地、香港、澳门、台湾、美国、加拿大、韩国、日本、新加坡、马来西亚以及泰国 )',
      t8: '( 适用于中国内地和香港 )',
      t9: '(只适用于香港地区)',
      t10: '(适用于多个地区)'
    }
  },
  provisionNumber: {
    info: {
      head: '开通号码',
      title: '开通手机号',
      tips: '每个帐户最多可以申请 2 个中国香港号码及 1 个中国内地号码。',
      no1: {
        title: '中国香港手机号',
        info: '2 款本地开通方式仼您选'
      },
      no2: {
        title: '中国内地手机号',
        info: '优惠期内限时 7 天免费试用'
      },
      no3: {
        title: '国外手机号',
        info: '多款本地开通方式仼您选'
      }
    },
    infoHk: {
      head: '中国香港手机号登记',
      headTips: '香港特区政府於2021年6月1日公布订立《电讯（登记用户识别卡）规例》，并於同年9月1日实施，以落实电话智能卡实名登记制度，保障健全的电讯服务及通讯网络的安全，防止和协助侦查涉及使用电话储值卡的罪案。',
      title: '开通中国香港手机号',
      tips: '每个帐户多个只可以申请 2 个中国香港手机号。',
      no1: {
        title: '一般手机号登记',
        info: '无SIM卡服务，App和微信收取短讯，App接听拨打电话'
      },
      no2: {
        title: '全新香港手机号码登记',
        info: '新号首发，限量供应',
        info2: '无SIM卡服务，App和微信收取短讯，App接听拨打电话'
      },
      no3: {
        title: '实体智能卡',
        info: '实体sim卡，含数据及语音'
      },
      no4: {
        title: 'eSIM',
        info: '只支援特定型号手机装置'
      },
      no5: {
        title: '携号转台 (MNP)',
        info: '需提供携号资料'
      }
    },
    infoCn: {
      head: '中国内地手机号',
      title: '开通中国内地号码',
      tips: '每个帐户只可以申请 1 个中国内地手机号。',
      no1: {
        title: '普通手机号码',
        info: '免费体验期 7 天，无sim卡，微信和 App 收取短讯、App接听拨打电话'
      },
      no2: {
        title: '特选号码',
        info: '配对特定计划'
      }
    },
    infoExt: {
      head: '訂購外國手機號',
      title: '訂購外國手機號',
      tips: '每個帳戶最多可以申請 X 個國外手機號。',
      areaTips: '請選擇地區...',
      area: {
        USA: '美国',
        UK: '英国',
        POL: '波兰'
      },
      no1: {
        title: '英國手機號',
        info: '無 SIM卡，微信和 App 收取短訊'
      },
      no2: {
        title: '美國手機號',
        info: '無 SIM卡，微信和 App 收取短訊'
      },
      no3: {
        title: '波兰手机号',
        info: '无 SIM卡，微信和 App 收取短讯'
      },
      no4: {
        title: '外国手机号',
        info: '英国 / 波兰 号码开通任您选'
      }
    }
  },
  payment: {
    head: '付款',
    title: '付款',
    phoneNo: '号码',
    topUpNo: '充值号码',
    amount: '交易金额',
    totalAmount: '总额',
    button: '付款',
    previous: '返回',
    paySuccess: '支付成功',
    confirm: '确定',
    chargeBalance: '支付金额',
    chargeType: '交易方式',
    tradeNo: '参考编号',
    payFail: '支付不成功',
    repay: '重新支付',
    canclePay: '取消交易',
    needHelp: '需要帮助?',
    confirmTips: '是否确定取消购买并离开？',
    confirmSure: '继续购买',
    confirmLeave: '离开购买',
    selectPayType: '请选择支付方式',
    money: {
      BALANCE: {
        title: '易博通余额',
        tips: ''
      },
      HKD: {
        title: '港币支付',
        tips: ''
      },
      CNY: {
        title: '人民币支付',
        tips: '当前汇率为 100人民币 = 100港币'
      },
      NTD: {
        title: '台币支付',
        tips: '台湾超商代码缴费（缴费后2小时生效）'
      },
      KRW: {
        title: '韩币支付',
        tips: '当前汇率为 160韩元 = 1港币'
      },
      RM: {
        title: '吉令支付',
        tips: '当前汇率为 60吉令 = 100港币'
      },
      RU: {
        title: '卢布支付',
        tips: ''
      }
    },
    payType: {
      A: '支付宝',
      B: '余额支付',
      W: '微信支付',
      AHK: '支付宝香港',
      WHK: '微信支付香港',
      U: '银联',
      P: 'Paypal',
      ABP: 'Aerobile Pay',
      L: 'LinePay',
      S: 'Google支付',
      KK: 'KakaoPay',
      TN: 'Touch\'n Go',
      GB: 'GrabPay',
      BT: 'Boost',
      MAY: 'Maybank',
      APP: 'Apple Pay',
      ASPA: 'Apple Pay',
      YOO: 'YooMoney',
      QIWI: 'QIWI'
    }
  },
  balanceInfo: {
    head: '余额充值',
    choosePhone: '选择号码',
    balance: '余额',
    authPass: '已实名认证',
    authFail: '未实名认证',
    auditing: '实名认证审核中',
    auditing2: '正在审核中',
    unAuth: '没有实名认证',
    unAuthStatus: '未实名认证，无法使用',
    balanceRecharge: '余额充值',
    tips1: '备注：充值余额，是不会延长该号码的服务期限，但如有足够余额便可用作购买套餐计划延长号码的有效期或发送短信。',
    tips2: '所预缴之费用将不获退还及/或不可兑换其他服务及/或产品。',
    nextButton: '下一步',
    noPhoneTips: '您当前没有号码，请先购买号码',
    status: '状态',
    normal: '正常',
    expired: '失效',
    active: '生效',
    numExpired: '过期',
    notRealName: '未实名',
    noNumber: '无号码',
    endDate: '到期日',
    notApplicable: '不适用'
  },
  payProcess: {
    tips1: '正在支付中',
    tips2: '请耐心等候，切勿关闭页面，系统正为您处理相关购买。',
    btn: '取消'
  },
  question: {
    title: '常见问题',
    title2: '我要反馈',
    line01: {
      title: '原微信用户，如何使用新版本APP？',
      content1: '第一步）先在新版本APP上，用电邮注册一个会员 ； 第二步）新会员登入APP ；第三步） 点击个人->点击顶端个人头像-登入方式绑定->快速登入设定，选择“微信绑定”； 第四步）绑定成功后，重新登入即可使用已办理的号码；',
      content2: ''
    },
    line02: {
      title: '易博通APP有哪几种拨号方式',
      content1: '',
      content2: ''
    },
    line03: {
      title: '易博通号码收发短信的规则是怎样的？',
      content1: '',
      content2: ''
    },
    line04: {
      title: '如何设置易博通APP系统权限【适用：Andriod】',
      content1: '以华为品牌手机为例，如下图：',
      content2: ''
    },
    line05: {
      title: '如何设置易博通APP后台运行？【适用：Andriod】',
      content1: '',
      content2: ''
    },
    line06: {
      title: '来电的时候，只听到铃声，看不到接听界面，如何设置？【适用：Andriod】',
      content1: '手机通知权限设置裡面所有能打开的权限全部打开【给予】，具体设置请参考手机说明书。',
      content2: ''
    },
    line07: {
      title: '如何查看已经办理的号码信息？',
      content1: '点击「个人」->「我的号码」',
      content2: ''
    },
    line08: {
      title: '发送短信时，出现“不正确的目的号码”，如何处理？',
      content1: '可能的原因是发送号码选择了易博通大陆号码，或者接收号码是大陆移动号码，具体请参考第3点：易博通号码收发短信规则。',
      content2: ''
    },
    line09: {
      title: '拨打电话时，出现闪断或者没反应，如何解决？',
      content1: '可能的原因是没有选择正确的主叫号码或者是错误的拨号方式，比如：主叫号码是易博通香港号码，但拨号时，没有输入正确的区号，具体请参考第2点：易博通APP拨号方式',
      content2: ''
    },
    line10: {
      title: '别人拨打我易博通号码时，无法拨通，如何解决？',
      content1: '可能的原因是易博通APP已经退出，请重新启动APP即可，如想保持APP一直在线状态，请在手机系统中设置APP后台运行权限，具体设置请参考第5点：设置易博通APP后台运行；',
      content2: ''
    },
    line11: {
      title: '电话接通时，对方听不到我说话或者我听不到对方说话，如何解决？',
      content1: '1）可能的原因是当前的网络信号不好，请使用WI-FI或者移动到网络好的地方再尝试',
      content2: '2）也有可能是手机的安全软件禁止易博通APP联网，请检查安全软件的设置，可以把易博通APP放入到安全软件的白名单中；'
    },
    line12: {
      title: 'APP升级后，每次打开APP时都需要重新登录，如何解决？【适用：Andriod】',
      content1: '请关闭易博通APP进程后，重新登录APP即可解决；',
      content2: ''
    },
    line13: {
      title: '登录时，出现登录异常界面，如何处理？',
      content1: '方法1: 检查手机的网络设置是否正常， 或者手机信号是否正常；',
      content2: '方法2: 如果方法1无法解决，请按照界面提示进行报障；'
    },
    line14: {
      title: '手机通知栏中看到短信通知信息，但进入APP后看不到该条短信？',
      content1: '估计是版本冲突造成的，请先卸载现有的APP版本，然后重新安装APP。',
      content2: ''
    }
  },
  feedback: {
    head: '我要反馈',
    title: '在您使用过程中，如有出现使用不顺畅的地方，请向我们反馈意见，帮助易博通产品不断改进。',
    time: '发生时间',
    year: '年',
    month: '月',
    day: '日',
    type: '问题类型',
    selectType: '请选择问题类型',
    cancle: '取消',
    sure: '确定',
    view: '问题表现',
    selectView: '请选择问题表现',
    net: '网络方式',
    selectNet: '请选择网络方式',
    region: '所在地区',
    inputRegion: '请输入所在地区',
    desc: '补充说明',
    descTip: '最多200字',
    contactInfo: '联络电邮',
    inputContactInfo: '请输入联络电邮',
    inputFailContactInfo: '电邮地址格式不正确',
    submit: '提交反馈',
    success: '您的反馈已经提交',
    fail: '提交失败',
    feedbackType: [{
      TYPE_ID: '1',
      TYPE_SORT: '1',
      TYPE_NAME: '网络问题'
    },
    {
      TYPE_ID: '2',
      TYPE_SORT: '2',
      TYPE_NAME: '权限问题'
    }
    ],
    networkInfo: [{
      NETWORK_ID: '1',
      TYPE_SORT: '1',
      NETWORK_NAME: 'WIFI'
    },
    {
      NETWORK_ID: '2',
      TYPE_SORT: '2',
      NETWORK_NAME: '3G'
    },
    {
      NETWORK_ID: '3',
      TYPE_SORT: '3',
      NETWORK_NAME: '4G'
    }
    ],
    feedbackDetail: [{
      TYPE_ID: '1',
      DETAIL_ID: '1',
      TYPE_SORT: '1',
      DETAIL_NAME: '断断续续'
    },
    {
      TYPE_ID: '1',
      DETAIL_ID: '2',
      TYPE_SORT: '2',
      DETAIL_NAME: '声音模糊'
    },
    {
      TYPE_ID: '2',
      DETAIL_ID: '3',
      TYPE_SORT: '3',
      DETAIL_NAME: '出错'
    },
    {
      TYPE_ID: '2',
      DETAIL_ID: '4',
      TYPE_SORT: '4',
      DETAIL_NAME: '体验差'
    }
    ]
  },
  realNameVerify: {
    head: '实名登记',
    idType: '证件类别',
    hkId: '香港身份证',
    cnId: '中华人民共和国居民身份证',
    upLoadFacePic: '上传证件正面照片',
    upLoadBackPic: '上传证件背面照片',
    upLoadTips: '请使用身份证明文件之正本进行实名登记。 照片需避免阻碍物或反光。',
    scan: '扫描',
    notice: '请输入与身份证明文件相同的资料。',
    idInputTitle: '证件号码',
    enNameInputTitle: '英文全名',
    nameIputTitle: '中文全名',
    finishBtn: '完成',
    success: '成功登记',
    fail: '登记失败',
    confirm: '确定',
    successTips: '阁下已经成功完成实名登记手续，我们将于半至 1 小时内进行资料审核，审核结果会发送到阁下所填报之电子邮箱内。如有任何问题请与我们联络，谢谢！',
    errorTips: {
      idNo: '请输入证件号码',
      enName: '请输入英文全名',
      name: '请输入中文全名',
      idFrontPic: '请上传证件正面照片',
      idBackPic: '请上传证件背面照片'
    }
  },
  business: {
    provision: {
      title: '中国香港手机号登记',
      registerErr: '预注册香港号码失败,请于10分钟后再试！',
      registerOk: '预注册香港号码成功',
      plan: {
        title: '香港免 SIM 卡服务',
        content: '无SIM卡，App收取短信，App接听拨打电话。App端单独购买的号码，不能在微信收取短信。',
        selectTip: '请选择你的计划.....',
        tip: '请先选择套餐',
        warn: '获取可选套餐列表失败'
      },
      number: {
        title: '选择心仪号码.....',
        content: '换一批号码',
        selectTip: '(只能换一次)',
        tip: '请先选择号码',
        warn: '获取可登记香港号码列表失败',
        tipTitle: '无法开通手机号',
        tipContent: '你的申请已达到上限，每个帐户最多可以申请 2 个中国香港手机号及 1 个中国内地手机号。'
      },
      member: {
        title: '香港免 SIM 卡服务',
        content: '香港特区政府于2021年6月1日公布订立《电讯（登记用户识别卡）规例》，并于同年9月1日实施，以落实电话智能卡实名登记制度，保障健全的电讯服务及通讯网络的安全，防止和协助侦查涉及使用电话储值卡的罪案。',
        userlabel: '客户资料',
        userTip: '输入姓名',
        userWarn: '请输入姓名',
        mobileTip: '输入联络电话',
        mobileWarn: '请输入正确的手机号码',
        codeLabel: '优惠码',
        codeTip: '优惠码（如有）',
        codeWarn: '请输入正确的优惠码',
        codeOk1: '成功使用，已额外获取 ',
        codeOk2: ' 天有效期',
        useCodeTip: '优惠码无效，是否继续购买?',
        useBut: '继续',
        cancleUseBut: '取消',
        mobilePrefixTitle: '选择电话区号',
        mobilePrefixList: [
          {name: '中国香港（+852）', value: '852'},
          {name: '中国内地（+86）', value: '86'},
          {name: '中国澳门（+853）', value: '853'},
          {name: '中国台湾（+886）', value: '886'},
          {name: '美国 / 加拿大（+1）', value: '1'},
          {name: '英国（+44）', value: '44'},
          {name: '马来西亚（+60）', value: '60'},
          {name: '澳洲（+61）', value: '61'},
          {name: '菲律宾（+63）', value: '63'},
          {name: '印尼（+62）', value: '62'},
          {name: '新加坡（+65）', value: '65'},
          {name: '泰国（+66）', value: '66'},
          {name: '日本（+81）', value: '81'},
          {name: '韩国（+82）', value: '82'},
          {name: '越南（+84）', value: '84'},
          {name: '法国（+33）', value: '33'},
          {name: '意大利（+39）', value: '39'},
          {name: '德国（+49）', value: '49'},
          {name: '其他', value: ''}
        ]
      },
      confirm: {
        title: '确认订单',
        tetle2: '香港免 SIM 卡服务',
        code: '优惠码',
        price: '总额',
        plan: '计划号码',
        username: '输入姓名',
        mobile: '联络电话',
        add: '加',
        day: '天有效期',
        update: '修改'
      },
      letter: {
        title: '「易博通」服务计划同意书（香港号码）',
        statement: '个人声明',
        statementInfo: '我已经阅读和了解广州博元讯息科技有限公司私隐政策及个人资料收集声明，第2条「收集个人资料」的规定，请在以下适当空格加上「√」号：',
        statementDetail1: '本人同意以上条款及细则。',
        statementDetail4: '本人同意博元使用本人的个人资料直接促销任何服务产品。',
        statementDetail2: '本人同意博元使用本人的个人资料，但仅限于延续服务安排及由博元直接提供的电讯服务 (包括但不限于流动语音，数据服务，国际漫游服务/长途电话服务产品促销资讯)。',
        statementDetail3: '本人不同意博元使用任何本人的个人资料促销用途。',
        content: [
          '以上服务提供于「易博通eSender」微信公众号及/或易博通APP绑定香港号码查阅及发送短讯服务。广州博元讯息科技有限公司 (「博元」) 亦可提供实体智能卡予客户携号转台或使用话音﹑数据及手机发送短讯服务，唯客户需要缴付智能卡费用及／或速递费用 (如适用)。话音﹑数据及手机发送短服务需另行收费。',
          '于易博通微信公众号及/或易博通APP发送短讯只提供予已选用套餐的户口，并需另行收费，费用会于户口内余额扣除，有关收费详情请浏览博元网页 www.multi-byte.com 或本公众号。',
          '当服务有效期届满前，博元将发送讯息予客户登记之香港号码提示客户，客户可于已于绑定香港号码的易博通微信公众号及/或易博通APP查阅，并可于效期届满前自行于易博通微信公众号﹑易博通APP或博元网页www.multi-byte.com 缴费以延长服务有效期。',
          '当服务有效期完结时，服务会被暂停。客户可于易博通微信公众号﹑易博通APP或博元网缴费并重启服务。暂停期间之讯息将不获补发。',
          '如服务因任何原故而停用超过 3 日或终止服务，客户同意届时必须放弃该分配的香港号码并归还予博元。',
          '服务计划中的香港号码不能更改。',
          '如服务因任何原故而停用，所预缴之费用将不获退还。',
          '任何优惠不得自由转让、退回现金及/ 或不可兑换其他服务及/ 或产品。',
          '根据香港《电讯 (登记用户识别卡) 规例》落实电话智能卡实名登记制度的实施安排，保障健全的电讯服务及通讯网络的安全，防止和协助侦查涉及使用电话储值卡的罪案。申请香港流动电话号码必须实名登记，个人用户须提供身分证明文件 (香港身份证或其他可接受的身分证明文件如旅客的“旅游证件”) 内的资料，包括姓名、出生日期和身分证明文件号码及其照片，以作登记。若公司或企业要登记成为电话智能卡用户，则须提供其商业登记资料及指定某人士作为代表或负责人，并提供该名人士的个人资料。16岁以下人士如需登记电话智能卡服务，相关登记必须得到一位成人的确认，电讯商亦会登记该名成人的资料。如阁下不提供个人资料，阁下将无法开通使用或继续使用涉及香港流动电话号码的电讯通讯服务，详情请浏览博元网页www.multi-byte.com。',
          '此服务受广州博元讯息科技有限公司的《一般条款及条件》约束，详情请浏览博元网页。',
          '上述资料为阁下自愿提供，如有资料错漏，博元讯息可能未能为阁下提供所申请之服务，博元讯息有权使用上述资料为阁下提供服务，通知阁下优惠推广活动，如有需要，披露予第三方作信用覆核﹑追讨债务﹑市场研究﹑及在法律规定下或遵从被认可之政府机关要求下披露及经阁下同意使用之其他用途。',
          '广州博元讯息科技有限公司保留更改本服务计划同意书之条款及条件与优惠之权利，恕不另行通知，遇有任何争议，概以博元之决定为最终决定，客户须受彼等约束。'
        ],
        warn: '请同意有关条款'
      },
      paySuccess: {
        hknum: '香港号码'
      }
    }
  },
  tokenFail: {
    title: '提示',
    msg: '登入会话已过期，请重新登入！',
    confirm: '确定'
  },
  ordinaryNum: {
    head: '中国内地手机号',
    title: '中国内地手机号码登记',
    topTips: '鉴于中国内地政府推行的流动电话号码实名登记政策，所有中国内地号码用户必须通过实名登记方能开通、使用或继续使用中国内地号码。每人只可以申请一个中国流动电话号码，登记可免费使用七天，如七天用完后想保留该号码继续使用，可付费充值。',
    title2: '确认订单',
    topTips2: '每人只可以申请一个中国流动电话号码，登记可免费使用七天，如七天用完后想保留该号码继续使用，可付费充值继续使用。',
    custInfo: '客户资料',
    idInfo: '证件类型',
    inputTips: {
      idType: '选择证件类型...',
      phone: '输入联络电话',
      idName: '输入姓名（与证件名字相同）',
      idNum: '输入证件号码',
      idFormat: '输入格式：AXXXXXXX',
      phoneNeed11: '请输入11位电话号码',
      phoneNeed8: '请输入8位电话号码',
      needHKId: '请输入有效的香港身份证',
      needCNId: '请输入有效的中国内地身份证'
    },
    confirm: {
      idName: '客户姓名',
      phone: '联络电话',
      idType: '证件类型',
      idNum: '证件号码'
    },
    idType: {
      CN: '中国内地身份证',
      CP: '中华人民共和国护照',
      FC: '外国人永久居留身份证',
      HK: '香港身份证',
      HM: '港澳居民来往内地通行证',
      MC: '澳门身份证',
      PP: '护照',
      RC: '国内居住证',
      TW: '台胞证'
    },
    btn: {
      back: '返回',
      next: '下一步',
      update: '修改',
      goToCharge: '结余充值',
      backIndex: '返回主页'
    },
    success: '成功申请',
    fail: '登记失败',
    successTitle: '中国内地号码',
    successTips: '恭喜！阁下已经成功申请中国大陆手机号免费体验七天！我们提供多款套餐供您订购，订购期内无限接收短信。如七天用完后想保留该号码继续使用，可付费充值继续使用。开始使用服务前，阁下必须前往「易博通 eSender」 微信公眾号进行实名登记。请阁下準备好登记号码的证件资料及个人半身实况照片。',
    letter: {
      title: '「易博通」服务计划同意书（中国内地号码）',
      statement: '个人声明',
      statementInfo: '我已经阅读及了解广州博元讯息科技有限公司私隐政策及个人资料收集声明，第2条「收集个人资料」的规定，请在以下适当空格加上「√」号：',
      statementDetail1: '本人同意以上条款及细则。',
      statementDetail4: '本人同意博元使用本人的个人资料直接促销任何服务产品。',
      statementDetail2: '本人同意博元使用本人的个人资料，但仅限于延续服务安排及由博元直接提供的电讯服务 (包括但不限于流动语音，数据服务，国际漫游服务/长途电话服务产品促销资讯)。',
      statementDetail3: '本人不同意博元使用任何本人的个人资料促销用途。',
      content: [
        '此服务提供于易博通微信公众号及/或易博通APP绑定中国内地号码查阅及发送短讯服务，发送短服务需另行收费。',
        '当服务有效期届满前，广州博元讯息科技有限公司 (「博元」) 将发送讯息予客户登记之中国内地号码提示客户，客户可于已于绑定中国内地号码的易博通微信公众号及/或易博通APP查阅，并可于效期届满前前自行于易博通微信公众号﹑易博通APP或博元网页www.multi-byte.com缴费以延长服务有效期。',
        '当服务有效期完结时，服务会被暂停。客户可于易博通微信公众号及/或易博通APP或博元网页缴费并重启服务。暂停期间之讯息将不获补发。',
        '如服务因任何原故而停用超过15日或终止服务，客户同意届时必须放弃该分配的中国内地号码并归还予博元。',
        '服务计划中的中国内地号码不能更改。',
        '服务计划中的中国内地号码祇适用于「易博通」服务。',
        '如服务因任何原故而停用，所预缴之费用将不获退还。',
        '任何优惠不得自由转让、退回现金及/ 或不可兑换其他服务及/ 或产品。',
        '中华人民共和国工业和信息部文件《电话用户真实身份信息登记实施规范》，申请中国内地流动电话号码必须实名登记，实名登记的年龄范围必须在16岁以上。博元须向阁下搜集阁下的个人资料，包括姓名、流动电话号码、联络方法﹑港澳身份证﹑台湾居民来往大陆通行证、中国公民身份证、护照或其它身份证明文件﹑免冠相片及自拍影片的资料等 (「上述资料」)，以协助阁下向中国内地当局办理实名登记 (「上述登记」)。上述资料会按中国内地政府推行的流动电话号码实名登记政策有所更改。阁下没有义务向博元提供上述资料，但如阁下不提供个人资料，中国内地当局会按相关政策指令停止阁下的中国内地号码服务，阁下将无法开通使用或继续使用涉及中国内地流动电话号码的电讯通讯服务，详情请浏览博元网页www.multi-byte.com。',
        '用户如有虚假交易的行为﹑以转售或诈骗为目的使用本服务，博元有权在无任何补偿或事先通知情况下，终止阁下的中国内地号码服务。',
        '用户不得将易博通服务用于电信资讯网路诈骗及其他违法行为，如出现电话诈骗、网路诈骗、垃圾短信投诉情况，博元有权在无任何补偿或事先通知情况下，永久终止阁下的易博通号码。',
        '此服务受广州博元讯息科技有限公司的《一般条款及条件》约束，详情请浏览博元网页www.multi-byte.com。',
        '上述资料为阁下自愿提供，如有资料错漏，博元讯息可能未能为阁下提供所申请之服务，博元讯息有权使用上述资料为阁下提供服务，通知阁下优惠推广活动，如有需要，披露予第三方作信用覆核﹑追讨债务﹑市场研究﹑及在法律规定下或遵从被认可之政府机关要求下披露及经阁下同意使用之其他用途。',
        '广州博元讯息科技有限公司保留更改本服务计划同意书之条款及条件与优惠之权利，恕不另行通知，遇有任何争议，概以博元之决定为最终决定，客户须受彼等约束。'
      ],
      warn: '请同意有关条款'
    }
  },
  buyRecord: {
    head: '交易纪录',
    number: '号码',
    plan: '计划',
    productType: '产品类型',
    orderTime: '交易时间',
    orderAmount: '交易金额',
    orderPayType: '交易方式',
    orderSn: '参考编号',
    noData: '您还没有订单'
  },
  addPackagePlan: {
    head: '加购计划',
    choosePlan: '请选择套餐'
  },
  smartSIMHK: {
    head: '实体智能卡',
    subTitle: '包括：实体 SIM 卡、 4G 数据、通话分钟、收取短讯',
    choosePlan: '请选择你的计划.....',
    planTips: '热门优选套餐',
    expressTips: '选择速递地区及收费',
    shippingAddressTips: '输入收货地址',
    expressArea: {
      china: '中国内地',
      hk: '香港',
      taiwan: '台湾',
      macao: '澳门',
      malaysia: '马来西亚',
      singapore: '新加坡'
    },
    expressWarn: '请选择速递地区及收费',
    addressWarn: '请输入收货地址',
    regTitle: '实体智能卡登记',
    regTips: '香港特区政府于2021年6月1日公布订立《电讯（登记用户识别卡）规例》，并于同年9月1日实施，以落实电话智能卡实名登记制度，保障健全的电讯服务及通讯网络的安全，防止和协助侦查涉及使用电话储值卡的罪案。',
    expressFee: '速递费用',
    consigneeDistrict: '速递地区',
    consigneeAddress: '收货地址',
    successTips: '恭喜！阁下已经成功购买套餐。实体智能卡会於 7 天工作日内按排寄出。寄出后会已电邮通知您。 感谢阁下使用易博通服务！'
  },
  specialCnNumber: {
    head: '特选号码',
    subTitle: '请输入您的心仪号码',
    fixedSection: '固定号码段',
    favoriteNumber: '心仪号码',
    find: '查找',
    notFindWarn: '找不到相关号码，请重新输入。',
    own: '可享',
    regTitle: '特选号码登记',
    regTips: '鉴于中国内地政府推行的流动电话号码实名登记政策，所有中国内地号码用户必须通过实名登记方能开通、使用或继续使用中国内地号码。每人只可以申请一个中国流动电话号码， 成功登记后可付费充值开启服务。',
    successTips1: '恭喜阁下已经成功申请易博通中国内地手机号， 如需要发出短信及通话，您可前往易博通微信公众号付费充值，你的号码亦可升级登记成为实体智能咭。 ',
    successTips2: '根据中国工信都相关条例，中国内地手机号必须实名认证后才可使用服务，请前往易博通微信公众号进行登记。'
  },
  ukPlan: {
    title: '英国手机号登记',
    registerErr: '预注册英国号码失败',
    registerOk: '预注册英国号码成功',
    plan: {
      title: '英国手机号',
      content: '无 SIM 卡，微信和 App 收取短讯',
      selectTip: '请选择你的计划.....',
      tip: '请先选择套餐',
      warn: '暂无套餐可供销售'
    },
    number: {
      title: '选择心仪号码.....',
      content: '换一批号码',
      selectTip: '(只能换一次)',
      tip: '请先选择号码',
      warn: '获取可登记英国号码列表失败',
      tipTitle: '无法开通手机号',
      tipContent: '你的申请已达到上限，每个帐户最多可以申请 1 个英国手机号。'
    },
    member: {
      title: '英国手机号',
      content: '此英国手机号套餐计划为无 SIM卡计划，计划只限于 APP或微信内收短讯使用。（计划并不包括通话、 发短讯和数据功能）',
      userlabel: '客户资料',
      userTip: '输入姓名',
      userWarn: '请输入姓名',
      mobileTip: '输入联络电话',
      mobileWarn: '请输入正确的手机号码',
      codeLabel: '优惠码',
      codeTip: '优惠码（如有）',
      codeTip2: '输入优惠码后， 在成功开通后可额外增加15日。',
      codeWarn: '请输入正确的优惠码',
      codeOk1: '成功使用，已额外获取 ',
      codeOk2: ' 天有效期',
      useCodeTip: '优惠码无效，是否继续购买?',
      useBut: '继续',
      cancleUseBut: '取消',
      mobilePrefixTitle: '选择电话区号',
      mobilePrefixList: [
        {name: '中国香港（+852）', value: '852'},
        {name: '中国内地（+86）', value: '86'},
        {name: '中国澳门（+853）', value: '853'},
        {name: '中国台湾（+886）', value: '886'},
        {name: '美国 / 加拿大（+1）', value: '1'},
        {name: '英国（+44）', value: '44'},
        {name: '马来西亚（+60）', value: '60'},
        {name: '澳洲（+61）', value: '61'},
        {name: '菲律宾（+63）', value: '63'},
        {name: '印尼（+62）', value: '62'},
        {name: '新加坡（+65）', value: '65'},
        {name: '泰国（+66）', value: '66'},
        {name: '日本（+81）', value: '81'},
        {name: '韩国（+82）', value: '82'},
        {name: '越南（+84）', value: '84'},
        {name: '法国（+33）', value: '33'},
        {name: '意大利（+39）', value: '39'},
        {name: '德国（+49）', value: '49'},
        {name: '其他', value: ''}
      ]
    },
    confirm: {
      title: '确认订单',
      tetle2: '英国手机号',
      code: '优惠码',
      price: '总额',
      plan: '计划号码',
      username: '输入姓名',
      mobile: '联络电话',
      add: '加',
      day: '天有效期',
      update: '修改'
    },
    letter: {
      title: '「易博通香港eSender HK」服务计划同意书（英国号码）',
      statement: '个人声明',
      statementInfo: '我已经阅读和了解广州博元讯息科技有限公司私隐政策及个人资料收集声明，第2条“收集个人资料”的规定，请在以下适当空格加上“√”号：',
      statementDetail1: '本人同意以上条款及细则。',
      statementDetail4: '本人同意博元使用本人的个人资料直接促销任何服务产品。',
      statementDetail2: '本人同意博元使用本人的个人资料，但仅限于延续服务安排及由博元直接提供的电讯服务 (包括但不限于流动语音，数据服务，国际漫游服务/长途电话服务产品促销资讯)。',
      statementDetail3: '本人不同意博元使用任何本人的个人资料促销用途。',
      content: [
        '以上服务提供于微信「易博通香港 eSender HK」公众号绑定英国号码查阅短讯服务。',
        '当服务有效期届满前，博元将发送消息提示给予已登记英国号码的客户，客户可于已于绑定英国号码的微信「易博通香港eSenderHK」之公众号查阅，并可于有效期届满前自行在本公众号缴费以延长服务有效期。',
        '当服务有效期完结时，服务会被暂停。 客户可于微信易博通香港eSender HK公众号缴费并重启服务。 暂停期间之讯息将不会补发。',
        '如服务因任何原故而停用超过3日或终止服务，客户必须同意放弃该分配的英国号码，并归还予博元。',
        '服务计划中嘅英国号码将不能更改。',
        '如服务因任何原故而停用，所预缴之费用将不获退还。',
        '任何优惠不得自由转让、退回现金及/或不可兑换其他服务及/或产品。',
        '此服务受博元讯息科技有限公司的《一般条款及条件》约束，详情请浏览博元网页。 ',
        '上述资料为阁下自愿提供，如资料有错漏，博元讯息可能未能为阁下提供所申请之服务。 博元讯息有权使用上述资料为阁下提供服务或通知阁下优惠推广活动。 如有需要，将披露予第三方作信用复核、追讨债务、市场研究、及在法律规定下或遵从被认可之政府机关要求下披露及经阁下同意使用之其他用途。',
        '博元讯息科技有限公司保留更改本服务计划同意书之条款及条件与优惠之权利，恕不另行通知，如有任何争议，概以博元之决定为最终决定，客户须受彼等约束。'
      ],
      warn: '请同意有关条款'
    }
  },
  traveleSimPlan: {
    head: '订购 eSIM',
    title: '订购 eSIM',
    tips1: '1. eSIM 计划不包括通话及收取短讯功能',
    tips2: '2. 每个帐户最多可以申请 5 张 eSIM',
    tips3: '3. 订购 eSIM 需额外支付 HK$20 登记费',
    moreEsim: '了解eSIM >',
    chooseArea: '请选择国家...',
    registerErr: '订购 eSIM失败',
    registerOk: '订购 eSIM成功',
    areaWarn: '获取地区列表失败',
    searchTips: '找寻目的地...',
    hotTips: '热门目的地',
    areaTips: '地区分类',
    buy: '购买',
    noData: '没有搜索结果',
    noSearchArea: '找不到相关国家/地区...',
    ApplicableTo: '适用于',
    Details: '详情',
    Description: '产品说明',
    Instructions: '产品须知',
    plan: {
      tips1: '1. eSIM 计划不包括通话及收取短讯功能 ',
      tips2: '2. 每个帐户最多可以申请 5 张 eSIM ',
      tips3: '3. 订购 eSIM 需额外支付 HK$20 登记费 ',
      tips4: '4. FUP：当资料流程量达到上述公平使用量(FUP)时， 资料传输速度将会被降至不低于 128kbps ',
      tips5: '5. 除非特别标明 “ * ”，所有网络均为4G，标明 “ * ” 之 地区，网络均为3G',
      selectTip: '请选择你的计划.....',
      tip: '请先选择套餐',
      warn: '获取可选套餐列表失败'
    },
    member: {
      title: '英国免 SIM 卡服务',
      content: '香港特区政府于2021年6月1日公布订立《电讯（登记用户识别卡）规例》，并于同年9月1日实施，以落实电话智能卡实名登记制度，保障健全的电讯服务及通讯网络的安全，防止和协助侦查涉及使用电话储值卡的罪桉。',
      userlabel: '客户资料',
      emailTip: '输入正确的电邮',
      emailWarn: '请输入正确的电邮',
      reEmailTip: '输入正确的确认电邮地址',
      reEmailWarn: '请输入正确的确认电邮地址',
      codeLabel: '优惠码',
      codeTip: '优惠码（如有）',
      codeWarn: '请输入正确的优惠码',
      codeOk1: '成功使用，已额外获取 ',
      codeOk2: ' 天有效期',
      useCodeTip: '优惠码无效，是否继续购买?',
      useBut: '继续',
      cancleUseBut: '取消',
      mobileTypeTips: '选择手机型号...',
      mobileTypeWarn: '请选择手机型号'
    },
    confirm: {
      title: '确认订单',
      code: '优惠码',
      price: '总额',
      plan: '计划号码',
      username: '输入姓名',
      mobile: '联络电话',
      add: '加',
      day: '天有效期',
      regPrice: 'eSIM 登记费',
      update: '修改',
      tips: '*eSIM 确认电邮将于大约 5 分钟内传送到阁下提供的电邮中。',
      email: '电邮地址'
    },
    letter: {
      title: '「易博通香港eSender HK」服务计划同意书（eSIM）',
      statement: '个人声明',
      statementInfo: '我已经阅读和了解广州博元讯息科技有限公司私隐政策及个人资料收集声明，第2条「收集个人资料」的规定，请在以下适当空格加上「√」号：',
      statementDetail1: '本人同意以上条款及细则。',
      statementDetail4: '本人同意博元使用本人的个人资料直接促销任何服务产品。',
      statementDetail2: '本人同意博元使用本人的个人资料，但仅限于延续服务安排及由博元直接提供的电讯服务 (包括但不限于流动语音，数据服务，国际漫游服务/长途电话服务产品促销资讯)。',
      statementDetail3: '本人不同意博元使用任何本人的个人资料促销用途。',
      content: [
        '现有易博通用户，无论是否开通有效的香港号码或中国号码，均可登记旅游eSIM。',
        '除非特别说明，旅游eSIM使用网路网路均为4G。',
        '每个微信帐号只限同时购买不多于三张易博通旅游eSIM。',
        '旅游eSIM 帐户和易博通香港号码帐户/易博通中国号码帐户(如有)完全独立，没有任何关联。',
        '旅游eSIM提供数据上网服务，话音及短讯服务并不适用，并不配有任何香港或中国号码。',
        '客户手机必须支援eSIM功能, 并必须于手机开启数据漫游，可以流览各种社交网路，随插即用，不需实名登记。',
        '用户必须于购买旅游eSIM起60天内启动旅游eSIM，逾期无效。',
        '服务有效期为启动当日起计算，每天00:00至23:59(均以北京时间为准)为一天使用时间，到期后数据服务将会暂停。 ',
        'Fair Usage Policy(FUP):当每天数据用量达套餐的公平使用量(FUP)时，数据传输速度将会被降至不低于128kbps; 高速数据传输速度将于第二天凌晨恢复。',
        '用户可于旅游eSIM启动后有效期内或到期后七日内即时充值延长天数以继续使用该旅游eSIM，到期日后七日如未充值，该旅游eSIM将会被终止。',
        '网络速度受多种因素影响，包括但不限于覆盖﹑客户器材﹑位置﹑网络设及流量情况等等。',
        '如客户身处4G覆盖以外地区，博元仍会透过3G/2G/EDGE 网络为客户提供服务。',
        '以上内容如有任何更改，恕不另行通知。博元讯息科技有限公司保留随时更改或终止以上条款的权利。'
      ],
      warn: '请同意有关条款'
    }
  },
  myProduct: {
    head: '我的手机号',
    menu: {
      all: '所有号码',
      hk: '香港号码',
      cn: '内地号码',
      eSim: 'eSim',
      ext: '国外号码'
    },
    normal: '正常',
    effective: '生效中',
    invalid: '已无效',
    active: '生效',
    planExpired: '套餐过期',
    expired: '过期',
    expiredNoBalance: '到期/没有结余',
    toBeRecycle: '号码即将回收',
    realName: '实名登记',
    notRealName: '未实名',
    addPlan: '加购套餐',
    balance: '余额',
    status: '状态',
    dueDate: '到期日',
    deadline: '激活限期',
    update: '更新',
    addPlanTips: '* 请于 *XX 天内加购套餐，否则号码将被取消。',
    realNameTips: '* 未有做实名登记，其短讯将无法送达。',
    activation: '激活',
    notActive: '未激活',
    isDel: '已删除',
    warn: '获取我的产品列表失败',
    notApplicable: '不适用',
    usedData: '已使用数据',
    typeInfo90: ['普通手机号码', '1.中国内地普通手机号计划为无 SIM卡计划，计划只限于 APP 内收短讯及接听拨打电话使用。（计划并不包括数据功能）', '2. * 每人只可以申请 1 个中国内地手机号并且必须通过电话智能卡实名登记后才可以使用。'],
    typeInfo91: ['免 SIM卡服务', '1.香港免 SIM卡套餐计划为无 SIM卡计划，计划只限于  APP 内收短讯及接听拨打电话使用。（计划并不包括数据功能）', '2. * 中国香港号码必须通过电话智能卡实名登记后才可以使用。'],
    typeInfo92: ['eSIM 服务', '1. eSIM 计划不包括通话及收取短讯功能。', '2. 网络：当数据用量达到适用于该客户之公平使用数据用量上限，资料传输速度将会被降至不低于 128kbps。'],
    typeInfo93: ['台湾号码服务', '台湾套餐计划为无 SIM卡计划，计划只限于 eSender APP 或微信内收短讯使用。（计划并不包括通话、 发短讯和数据功能）'],
    typeInfo94: ['美国号码服务', '美国套餐计划为无 SIM卡计划，计划只限于 eSender APP 或微信内收短讯使用。（计划并不包括通话、 发短讯和数据功能）'],
    typeInfo95: ['英国号码服务', '英国套餐计划为无 SIM卡计划，计划只限于 eSender APP 或微信内收短讯使用。（计划并不包括通话、 发短讯和数据功能）'],
    typeInfo96: ['马来西亚号码服务', '马来西亚套餐计划为无 SIM卡计划，计划只限于 eSender APP 或微信内收短讯使用。（计划并不包括通话、 发短讯和数据功能）']
  },
  eSimTopUp: {
    head: 'eSIM 充值',
    choosESIM: '选择 eSIM',
    choosPlan: '请选择套餐',
    topUp: '充值',
    update: '更新',
    registerErr: 'eSIM 充值失败',
    getListWarn: '获取eSIM 充值列表失败',
    noData: '没有可以充值的 eSIM'
  },
  contactUs: {
    t1: '博元微信公众号',
    tips1: '1. 储存二维码到手机，启动微信应用程式',
    tips2: '2. 按画面按右上方的“+”，再按“扫描”并打开相簿点选已储存的QR Code',
    tips3: '3. 扫描后进入“博元讯息”官方帐户，按“关注”即可浏览',
    btn: '储存二维码'
  },
  gs: {
    payment: {
      redemSuccess: '兑换成功',
      redemFail: '兑换失败',
      confirm: '确认'
    },
    rate: {
      title: 'Travel Call IDD收费表',
      searchNoResult: '无结果',
      searchTip: '搜索',
      tableTitleLeft: '国家 / 地区',
      tableTitleCenter: '区号',
      tableTitleRight: '收费',
      tableTitleRightUnit: '(HKD/分钟)',
      cancel: '取消',
      tipTitle: '温馨说明',
      tip1: '1. 以下收费以港币为单位；所有收费以每分钟计算，不足一分钟亦作一分钟计算。',
      tip2: '2. 香港号码长途电话服务需另外计算香港/中港通话分钟或香港/中港通话分钟收费。',
      tip3: '3. 阿東基有限公司 保留对以下优惠条款及细则之最终决定权。收费如有更改恕不另行通知。'
    },
    company: {
      title: '关于阿東基',
      ERCodeDesc: '阿東基 (ADONKILIMITED)',
      info: '阿東基(ADONKILIMITED)为一家专营全球各地上网卡 数据卡 电话卡专门店 设24小时网购平台,免费平邮、全港顺丰站及工商业地址快递等寄取服务，我们提供免费专人whatsapp技术支援，我们的宗旨帮你以最抵价格买到心水产品。',
      gotoMB: '前往网站'
    },
    privacyText: {
      title: 'Travel Call隐私政策',
      summary:
        {
          title: '摘要',
          text: '阿東基。（“  Travel Call ”或“我们”或“我们的”或“我们的”或其他类似代词）非常重视您的隐私问题。请阅读以下内容，以了解有关我们的隐私政策（“政策”）的更多信息。本政策详细说明了我们如何接收，收集和使用 Travel Call 软件上提供服务有关的信息。 （以上统称为“服务”）。使用本服务时，即表示您接受本政策中所述的政策和惯例，因为该政策可能会不时进行修改。每次您使用服务时，即表示您同意并明确同意我们按照本政策的规定收集，使用和披露您提供的信息。'
        },
      one: {
        title: '一.我们会收集阁下的哪些资讯？',
        text1: '若阁下设定Travel Call 帐户，并使用 Travel Call 提供的服务，我们将会收集阁下的资讯。我们会收集阁下的',
        text2: '设备型号、操作系统、位置信息、手机读写、麦克风、通讯录、摄像头、唯一设备标识符、登录IP地址、接入网络的方式、类型和状态、网络质量数据、操作日志、昵称、手机号码以及通话和短信记录',
        text3: '，这些信息是为提供服务必须收集的基础信息。同时阁下可以提供更多资讯，让阁下的个人资料更精细与受欢迎，所收集到的信息我们将妥善存储和谨慎使用。'
      },
      two: {
        title: '二.第三方SDK目录',
        substile1: '1) 极光(Jiguang)推送SDK，为 APP 用户提供信息推送服务',
        text2: 'A.获取权限：',
        text3: '•获取您的设备信息,包括IMEI、IDFA、Android ID、GAID、MAC、OAID、IMSI、MEID、UAID）：用于生成脱敏的终端用户设备唯一性标识，以确保能准确进行消息推送，用于用户操作行为记录；',
        text4: '•获取您的读写外部存储（包括设备型号、设备屏幕分辨率、设备硬件制造商、设备产品名称）：用于保证服务在不同设备上的兼容性，确保消息准确下发；',
        text5: '•查看您的网络链接状态 （包括网络类型、运营商名称、基站信息、IP地址、WiFi信息、SSID、BSSID）：用于判断SDK与服务器的网络连接状态，保证服务的稳定性和连续性；',
        text6: 'B.使用目的',
        text7: '•推送消息,用于您查询推送服务记录，了解推送信息送达的情况。',
        text8: 'C.处理方式',
        text9: '•采用替换，去标识，加密，匿名化方式对个人信息进行脱敏展示',
        text10: 'D.极光隐私协议',
        subtitle2: '2)友盟UShare SDK',
        text20: '为了向阁下提供一键分享服务，我们的产品集成友盟+ Ushare SDK，友盟Ushare SDK需要收集阁下的 设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息）以及阁下需要分享的社交账号公开信息，以便完成一键分享服务。并通过地理位置校准报表数据准确性，提供基础反作弊服务。为了阁下的信息安全，我们已与第三方SDK服务商进行数据安全保密约定，这些公司会严格遵守我们的数据隐私和安全要求。\n' +
          '        除非得到阁下的同意，我们不会与其共享阁下的个人身份信息。为便于阁下更好地了解【友盟+】采集的数据类型及用途，以及何保护阁下的个人信息.',
        text21: '阁下可以登陆',
        text22: '了解【友盟+】隐私权政策 .',
        subtitle3: '3) 腾讯Bugly SDK',
        text30: '为了更好排查崩溃问题,帮助APP提升稳定性，我们的产品集成了腾讯Bugly SDK，腾讯Bugly SDK需要收集Android系统版本，厂商系统版本，内存空间占用大小等信息，为了阁下的信息安全，我们已与第三方SDK服务商进行数据安全保密约定，这些公司会严格遵守我们的数据隐私和安全要求。 除非得到阁下的同意，我们不会与其共享阁下的个人身份信息。为便于阁下更好地了解【Bugly SDK】采集的数据类型及用途，以及何保护阁下的个人信息.',
        text31: '阁下可以访问 ',
        text32: ', 了解Bugly SDK隐私保护声明.'
      },
      three: {
        title: '三.我们会如何使用阁下的资讯？',
        text1: '我们会使用阁下的资讯来提供阁下的 Travel Call 服务，允许阁下与其他使用者通讯，以及使用 Travel Call 公开平台的功能。我们会使用阁下的资讯来设定帐户、促进通讯、提供支援、允许阁下存取 Travel Call 功能，并改善 Travel Call 服务。 Travel Call 会使用阁下所使用的WeChat应用，以验证及保护阁下的帐户，也会为重要管理因素而使用，且 Travel Call 不会将这些联络管道用于推销或行销。'
      },
      four: {
        title: '四.我们会与谁分享阁下的资料？',
        text1: '我们会使用第三方支援服务，例如使用WeChat公共平台来提供帐户验证服务。我们使用这些第三方服务来处理或储存阁下的资讯时，会以本政策所载的目的为限。我们也会和阿東基相关集团公司共用阁下的资讯，并根据法律要求来共用。除以上所列之目的外，若无阁下的事前明文同意， Travel Call 不会与第三方共用阁下的资料。任何我们与之分享用户资讯的第三方服务商（由我们所拣选），都会提供与本政策所述相同，或者同等级的用户资讯保护标准。'
      },
      five: {
        title: '五.我们保留阁下资料的时间会持续多久？',
        text1: '我们保留阁下资讯的时间会依据资讯类型而定，例如登入资料会保留长达 90 天，自收集资料之日起算。'
      },
      six: {
        title: '六.我要如何行使我对资料的权利？',
        text1: '阁下对阁下的资料及我们使用阁下资料的方式有特殊权利。这些权利包含阁下存取资料的方式、消除资料的方式、限制使用阁下资料的方式、拒绝使用资料，以及取得阁下的资讯副本。'
      },
      seven: {
        title: '七.争议解决',
        text1: '感谢您选购阿東基的产品。如果您有任何疑问，需要特别技术帮助/产品问题，请直接通过以下方式与我们联繫。我们希望能收到您的来信，并儘最大努力为您提供所有解决方案。',
        text2: '',
        text3: 'E-mail: contact@travelcall.net'
      },
      eight: {
        title: '八.我们如何向阁下通知变更？',
        text1: ' 若本隐私政策有任何重大变更，在变更生效前，我们会传送通知给阁下。',
        text2: '我们重视阁下的隐私。本隐私政策旨在告知阁下，对于阁下向我们提供的任何资讯，或阁下因使用 Travel Call 而产生之资讯，阁下可以做出的选择以及我们的惯例。',
        text3: '使用我们的服务（例如 Travel Call 行动应用程式、阿東基公司网站  adonkilimited.com 或提供 Travel Call 服务之任何第三方平台）（合称为“ Travel Call ”）包含处理阁下的资讯之行为。阁下有必要了解对阁下资讯的收集与使用过程，以及阁下可以如何对其进行管理，这些都是很重要的资讯。请详阅此隐私政策。'
      },
      nice: {
        title: '九.联络我们',
        text1: '感谢您选购阿東基的产品。如果您有任何疑问，需要特别技术帮助/产品问题，请直接通过以下方式与我们联繫。我们希望能收到您的来信，并儘最大努力为您提供所有解决方案。',
        text2: '',
        text3: 'E-mail: contact@travelcall.net'
      },
      update: {
        text1: '阿東基有限公司-最后修订'
      }
    },
    regulation: {
      title: ' Travel Call 服务条款',
      clause: {
        clauseTitle1: ' “ Travel Call ”服务计划同意书 (香港号码)',
        clause1: ' 1、以上服务提供于微信“ Travel Call ”公众号绑定香港号码查阅及发送短讯服务。阿東基(“阿東基”)亦可提供实体智能卡予客户携号转台或使用话音﹑数据及手机发送短讯服务，唯客户需要缴付智能卡费用及／或速递费用（如适用）。话音﹑数据及手机发送短服务需另行收费。',
        clause2: ' 2、于微信发送短讯只提供予已选用套餐的户口，并需另行收费，费用会于户口内余额扣除，有关收费详情请浏览阿東基网页adonkilimited.com或本公众号',
        clause3: ' 3、当服务有效期届满前，阿東基将发送讯息予客户登记之香港号码提示客户，客户可于已于绑定香港号码的微信“ Travel Call ”公众号查阅，并可于效期届满前自行于本公众号或阿東基网页adonkilimited.com缴费以延长服务有效期',
        clause4: ' 4、当服务有效期完结时，服务会被暂停。客户可于微信或阿東基网页缴费并重启服务。暂停期间之讯息将不获补发',
        clause5: ' 5、如服务因任何原故而停用超过7日或终止服务，客户同意届时必须放弃该分配的香港号码并归还予阿東基',
        clause6: ' 6、服务计划中的香港号码不能更改',
        clause7: ' 7、如服务因任何原故而停用，所预缴之费用将不获退还',
        clause8: ' 8、任何优惠不得自由转让、退回现金及/ 或不可兑换其他服务及/ 或产品。',
        clause9: ' 9、此服务受阿東基的《一般条款及条件》约束，详情请浏览阿東基网页',
        clause10: ' 10、上述资料为阁下自愿提供，如有资料错漏，阿東基可能未能为阁下提供所申请之服务，阿東基有权使用上述资料为阁下提供服务，通知阁下优惠推广活动，如有需要，披露予第三方作信用覆核﹑追讨债务﹑市场研究﹑及在法律规定下或遵从被认可之政府机关要求下披露及经阁下同意使用之其他用途',
        clause11: ' 11、阿東基保留更改本服务计划同意书之条款及条件与优惠之权利，恕不另行通知，遇有任何争议，概以阿東基之决定为最终决定，客户须受彼等约束',
        clauseTitle2: ' “ Travel Call ”服务计划同意书 (香港号码-携号转台服务)',
        clause12: ' 12、以上服务提供于微信“ Travel Call ”公众号绑定香港号码查阅及发送短讯服务。阿東基(“ Travel Call ”)亦可提供实体智能卡予客户携号转台或使用话音﹑数据及手机发送短讯服务，唯客户需要缴付智能卡费用及／或速递费用（如适用）。话音﹑数据及手机发送短服务需另行收费',
        clause13: ' 13、于微信发送短讯只提供予已选用套餐的户口，并需另行收费，费用会于户口内余额扣除，有关收费详情请浏览阿東基网页adonkilimited.com或本公众号',
        clause14: ' 14、当服务有效期届满前，阿東基将发送讯息予客户登记之香港号码提示客户，客户可于已于绑定香港号码的微信 “ Travel Call ”公众号查阅，并可于效期届满前自行于本公众号或阿東基网页www.阿東基.hk缴费以延长服务有效期',
        clause15: ' 15、当服务有效期完结时，服务会被暂停。客户可于微信或阿東基网页缴费并重启服务。暂停期间之讯息将不获补发',
        clause16: ' 16、如服务因任何原故而停用超过7日或终止服务，客户同意届时必须放弃该分配的香港号码并归还予阿東基',
        clause17: ' 17、服务计划中的香港号码不能更改',
        clause18: ' 18、如服务因任何原故而停用，所预缴之费用将不获退还',
        clause19: ' 19、任何优惠不得自由转让、退回现金及/ 或不可兑换其他服务及/ 或产品',
        clause20: ' 20、本人明白有关流动号码的转携并不影响有关流动号码成功转携前本人在供号网络营办商适用的服务条款与细则下对供号网络营办商的责任',
        clause22: ' 21、生效时间受供号网络营办商确认上述资料及供号网络营办商与阿東基之间按电讯管理局局长所发出的与实施流动电话号码可携性有关的实务守则技术安排的限制。阿東基获明示授权更改阿東基合理地认为合适的生效时间',
        clause23: ' 22、有关流动号码若由于本人未有提供完整的资料，或提供错误或失实的资料或因阿東基未能合理控制的任何理由，而导致流动电话号码无法携带至阿東基的网络，阿東基有权取消本转携申请',
        clause24: ' 23、除任何无法卸除的法律责任外，本人同意因本申请和相关号码转携安排引致或造成本人或其他任何人士蒙受损失或损害，阿東基无需对本人或任何其他人士负上法律责任 (不论是在合约、侵权或其他方面)。 ',
        clause25: ' 24、此服务受阿東基的《一般条款及条件》约束，详情请浏览阿東基网页',
        clause26: ' 25、上述资料为阁下自愿提供，如有资料错漏，阿東基可能未能为阁下提供所申请之服务，阿東基有权使用上述资料为阁下提供服务，通知阁下优惠推广活动，如有需要，披露予第三方作信用覆核﹑追讨债务﹑市场研究﹑及在法律规定下或遵从被认可之政府机关要求下披露及经阁下同意使用之其他用途',
        clause27: ' 26、阿東基保留更改本服务计划同意书之条款及条件与优惠之权利，恕不另行通知，遇有任何争议，概以阿東基之决定为最终决定，客户须受彼等约束',
        clauseTitle3: ' “ Travel Call ”服务计划同意书 (中国内地号码)',
        clause28: ' 27、以上服务不提供实体智能卡',
        clause29: ' 28、以上服务只提供于“ Travel Call ”微信公众号绑定中国内地号码查阅及发送短讯服务，现阶段并不包括话音或数据服务。发送短讯只提供予已选用套餐的户口，并需另行收费，费用会于户口内余额扣除，有关收费详情请浏览阿東基网页adonkilimited.com',
        clause30: ' 29、当服务有效期届满前，阿東基(“ADONKI”)将发送讯息予客户登记之中国内地号码提示客户，客户可于已于绑定中国内地号码的“  Travel Call ”微信公众号查阅，并可于效期届满前自行于微信或阿東基网页阿東基缴费以延长服务有效期',
        clause31: ' 30、当服务有效期完结时，服务会被暂停。客户可于微信或阿東基网页缴费并重启服务。暂停期间之讯息将不获补发',
        clause32: ' 31、如服务因任何原故而停用超过30日或终止服务，客户同意届时必须放弃该分配的中国内地号码并归还予阿東基',
        clause33: ' 32、服务计划中的中国内地号码不能更改',
        clause34: ' 33、服务计划中的中国内地号码祇适用于“ Travel Call ”服务',
        clause35: ' 34、如服务因任何原故而停用，所预缴之费用将不获退还',
        clause36: ' 35、任何优惠不得自由转让、退回现金及/ 或不可兑换其他服务及/ 或产品',
        clause37: ' 36、中华人民共和国工业和信息部文件《电话用户真实身份信息登记实施规范》，申请中国内地流动电话号码必须实名登记，实名登记的年龄范围必须在16岁以上。阿東基须向阁下搜集阁下的个人资料，包括姓名、流动电话号码、联络方法﹑港澳身份证﹑台湾居民来往大陆通行证、中国公民身份证、护照或其它身份证明文件﹑免冠相片及自拍影片的资料等(“上述资料”)，以协助阁下向中国内地当局办理实名登记(“上述登记”)。上述资料会按中国内地政府推行的流动电话号码实名登记政策有所更改。阁下没有义务向阿東基提供上述资料，但如阁下不提供个人资料，中国内地当局会按相关政策指令停止阁下的中国内地号码服务，阁下将无法开通使用或继续使用涉及中国内地流动电话号码的电讯通讯服务，详情请浏览阿東基网页adonkilimited.com',
        clause38: ' 37、用户如有虚假交易的行为﹑以转售或诈骗为目的使用本服务，阿東基有权在无任何补偿或事先通知情况下，终止阁下的中国内地号码服务',
        clause39: ' 38、用户不得将 Travel Call 服务用于电信资讯网路诈骗及其他违法行为，如出现电话诈骗、网路诈骗、垃圾短信投诉情况，阿東基有权在无任何补偿或事先通知情况下，永久终止阁下的 Travel Call 号码。',
        clause40: ' 39、此服务受阿東基的《一般条款及条件》约束，详情请浏览阿東基网页adonkilimited.com',
        clause41: ' 40、上述资料为阁下自愿提供，如有资料错漏，阿東基可能未能为阁下提供所申请之服务，阿東基有权使用上述资料为阁下提供服务，通知阁下优惠推广活动，如有需要，披露予第三方作信用覆核﹑追讨债务﹑市场研究﹑及在法律规定下或遵从被认可之政府机关要求下披露及经阁下同意使用之其他用途',
        clause42: ' 41、阿東基保留更改本服务计划同意书之条款及条件与优惠之权利，恕不另行通知，遇有任何争议，概以阿東基之决定为最终决定，客户须受彼等约束',
        clauseEnd: ' 本人/本公司已细阅及明白本附加协议之条款/及条件，并同意受彼等约束。'
      }
    },
    charge: {
      title: ' Travel Call 产品收费表',
      select: {
        option1: '所有套餐',
        option2: '中国香港号码套餐',
        option3: '中国内地号码套餐'
      },
      price: '价钱',
      dayNum: '日数',
      receiveMsg: '接收短讯',
      data: '流动数据',
      limitless: '无限',
      service: '服务',
      phoneTime: '通话分钟',
      phoneTimeAndData: '通话分钟、流动数据',
      notAvailable: '不适用',
      day: '天',
      minute: '分钟',
      hk: '(香港)',
      mo: '(澳门)',
      cn_mo: '(中国及澳门)',
      hkTableTitle: '香港号码套餐',
      package: {
        p1: '微信收短信 （免SIM卡套餐）',
        p2: '实体 SIM 卡',
        p3: 'eSIM 套餐',
        p4: '实体 SIM 卡'
      },
      tips: {
        t1: '(只适用于香港地区)',
        t2: '( 适用于中国香港 )',
        t3: '(只适用于香港及澳门地区)',
        t4: '( 适用于中国香港及澳门 )',
        t5: '( 适用于中国香港及澳门 )',
        t6: '( 适用于中国内地、香港、澳门、台湾 )',
        t7: '( 适用于中国内地、香港、澳门、台湾、美国、加拿大、韩国、日本、新加坡、马来西亚以及泰国 )',
        t8: '( 适用于中国内地和香港 )',
        t9: '(只适用于香港地区)',
        t10: '(适用于多个地区)'
      }
    },
    question: {
      title: ' Travel Call 常见问题',
      title2: '我要反馈',
      line01: {
        title: '原微信用户，如何使用新版本APP？',
        content1: '第一步）先在新版本APP上，用电邮注册一个会员 ； 第二步）新会员登入APP ；第三步） App首页->兑换香港号码； 第四步）ICCID绑定成功后，重新登入即可使用已办理的号码；',
        content2: ''
      },
      line02: {
        title: 'Travel Call APP有哪几种拨号方式【适用：iOS/Andriod】',
        content1: '',
        content2: ''
      },
      line03: {
        title: ' Travel Call  号码收发短信的规则是怎样的？【适用：iOS/Andriod】',
        content1: '',
        content2: ''
      },
      line04: {
        title: '如何设置Travel Call APP系统权限【适用：Andriod】',
        content1: '以华为品牌手机为例，如下图：',
        content2: ''
      },
      line05: {
        title: '如何设置Travel Call APP后台运行？【适用：Andriod】',
        content1: '',
        content2: ''
      },
      line06: {
        title: '来电的时候，只听到铃声，看不到接听界面，如何设置？【适用：Andriod】',
        content1: '手机通知权限设置裡面所有能打开的权限全部打开【给予】，具体设置请参考手机说明书。',
        content2: ''
      },
      line07: {
        title: '如何查看已经办理的号码信息？【适用：iOS/Andriod】',
        content1: '点击「个人」->「我的产品」',
        content2: ''
      },
      line08: {
        title: '发送短信时，出现“不正确的目的号码”，如何处理？【适用：iOS/Andriod】',
        content1: '可能的原因是发送号码选择了 Travel Call 大陆号码，或者接收号码是大陆移动号码，具体请参考第3点： Travel Call 号码收发短信规则。',
        content2: ''
      },
      line09: {
        title: '拨打电话时，出现闪断或者没反应，如何解决？【适用：iOS/Andriod】',
        content1: '可能的原因是没有选择正确的主叫号码或者是错误的拨号方式，比如：主叫号码是 Travel Call 香港号码，但拨号时，没有输入正确的区号，具体请参考第2点： Travel Call APP拨号方式',
        content2: ''
      },
      line10: {
        title: '别人拨打我 Travel Call 号码时，无法拨通，如何解决？【适用：iOS/Andriod】',
        content1: '可能的原因是Travel Call APP已经退出，请重新启动APP即可，如想保持APP一直在线状态，请在手机系统中设置APP后台运行权限，具体设置请参考第5点：设置 Travel Call APP后台运行；',
        content2: ''
      },
      line11: {
        title: '电话接通时，对方听不到我说话或者我听不到对方说话，如何解决？【适用：iOS/Andriod】',
        content1: '1）可能的原因是当前的网络信号不好，请使用WI-FI或者移动到网络好的地方再尝试',
        content2: '2）也有可能是手机的安全软件禁止 Travel Call APP联网，请检查安全软件的设置，可以把 Travel Call APP放入到安全软件的白名单中；'
      },
      line12: {
        title: 'APP升级后，每次打开APP时都需要重新登录，如何解决？【适用：Andriod】',
        content1: '请关闭 Travel Call APP进程后，重新登录APP即可解决；',
        content2: ''
      },
      line13: {
        title: '登录时，出现登录异常界面，如何处理？【适用：iOS/Andriod】',
        content1: '方法1: 检查手机的网络设置是否正常， 或者手机信号是否正常；',
        content2: '方法2: 如果方法1无法解决，请按照界面提示进行报障；'
      },
      line14: {
        title: '手机通知栏中看到短信通知信息，但进入APP后看不到该条短信？【适用：iOS/Andriod】',
        content1: '估计是版本冲突造成的，请先卸载现有的APP版本，然后重新安装APP。',
        content2: ''
      }
    },
    feedback: {
      head: '我要反馈',
      title: '在您使用过程中，如有出现使用不顺畅的地方，请向我们反馈意见，帮助 Travel Call产品不断改进。',
      time: '发生时间',
      year: '年',
      month: '月',
      day: '日',
      type: '问题类型',
      selectType: '请选择问题类型',
      cancle: '取消',
      sure: '确定',
      view: '问题表现',
      selectView: '请选择问题表现',
      net: '网络方式',
      selectNet: '请选择网络方式',
      region: '所在地区',
      inputRegion: '请输入所在地区',
      desc: '补充说明',
      descTip: '最多200字',
      contactInfo: '联络电邮',
      inputContactInfo: '请输入联络电邮',
      inputFailContactInfo: '电邮地址格式不正确',
      submit: '提交反馈',
      success: '提交成功！',
      successTips1: '如需更快捷的服务，请透过WhatsApp 同我们联络：+852 6398 7656',
      successTips2: '周一至周日 12:00-21:00',
      successBtn: '我知道了',
      fail: '提交失败',
      feedbackType: [{
        TYPE_ID: '1',
        TYPE_SORT: '1',
        TYPE_NAME: '网络问题'
      },
      {
        TYPE_ID: '2',
        TYPE_SORT: '2',
        TYPE_NAME: '权限问题'
      }
      ],
      networkInfo: [{
        NETWORK_ID: '1',
        TYPE_SORT: '1',
        NETWORK_NAME: 'WIFI'
      },
      {
        NETWORK_ID: '2',
        TYPE_SORT: '2',
        NETWORK_NAME: '3G'
      },
      {
        NETWORK_ID: '3',
        TYPE_SORT: '3',
        NETWORK_NAME: '4G'
      }
      ],
      feedbackDetail: [{
        TYPE_ID: '1',
        DETAIL_ID: '1',
        TYPE_SORT: '1',
        DETAIL_NAME: '断断续续'
      },
      {
        TYPE_ID: '1',
        DETAIL_ID: '2',
        TYPE_SORT: '2',
        DETAIL_NAME: '声音模糊'
      },
      {
        TYPE_ID: '2',
        DETAIL_ID: '3',
        TYPE_SORT: '3',
        DETAIL_NAME: '出错'
      },
      {
        TYPE_ID: '2',
        DETAIL_ID: '4',
        TYPE_SORT: '4',
        DETAIL_NAME: '体验差'
      }
      ]
    },
    contactUs: {
      t1: '阿東基 微信公众号',
      tips1: '1. 储存二维码到手机，启动微信应用程式',
      tips2: '2. 按画面按右上方的“+”，再按“扫描”并打开相簿点选已储存的QR Code',
      tips3: '3. 扫描后进入“博元讯息”官方帐户，按“关注”即可浏览',
      btn: '储存二维码'
    },
    bindICCID: {
      head: '兑换香港号码',
      label: {
        iccid: 'ICCID ',
        iccidWhere: '（储值卡上 20 位数） ',
        pin: 'PIN码 ',
        verifyPin: 'PIN码（储值卡上 6 位数） ',
        pinWhere: '请在储值卡上找到 6 位PIN码数字',
        canNotFindPin: '无法使用PIN码？',
        canNotUsePinTips1: '如阁下失去了PIN码，请透过电话联络我们客户服务专员：(852) 6469 6649 。',
        canNotUsePinTips2: '（ 星期一至五 早上 9:00 - 下午 6:00 ）',
        sysErrorTips: '系统繁忙，请稍后再试或者联系客服人员! ',
        exchangeSuccess: '兑换成功! '
      },
      btn: {
        confirm: '确认',
        exchange: '兑换'
      },
      inputTips: {
        iccid: '输入 20 位 ICCID ',
        pin: '输入 6 位 PIN码 '
      },
      whatIccidTips: {
        title: '什么是 ICCID？',
        tips: '如上图红框所示，于阁下已购买的储值卡上印有 20 位 ICCID 识别码，请输入该 ICCID 别码进行验证。'
      },
      whatPinTips: {
        title: 'PIN码位置',
        tips: '如上图红框所示，于阁下已购买的储值卡上印有 6 位储值卡密码（SIM PIN）请输入该 PIN 码进行验证。'
      }
    }
  },
  delUserData: {
    head: '清除用户数据',
    stepList: ['输入Email', '->验证Email', '->确认删除', '->数据清理'],
    esT1: '应用名称(App Name): eSender',
    esT2: '开发商(Developer): Multibyte Info Technology Ltd.',
    gsT1: '应用名称(App Name): Travel Call',
    gsT2: '开发商(Developer): ADONKI LIMITED',
    label1: '请输入你的账号邮箱:',
    label2: '说明: 该邮箱为你注册账号时的有效邮箱地址',
    label3: '请输入验证码:',
    label4: '我们需要验证您的身份，已将验证信息传送到:',
    label5: '请在10分钟内内输入验证码',
    label6: '校验通过，您是否确认删除账号',
    label7: '及相关数据?',
    label8: '一旦确认，您的账号及数据将永久删除。',
    label9: '您的账号及数据已被清除,再次感谢使用我们的产品,如需重新使用我们的产品，请再次注册即可:',
    inputTip1: '请输入正确的电邮',
    inputTip2: '请输入正确的验证码',
    fail1: '验证信息传送失败，请联系管理员',
    fail2: '验证码验证失败，请联系管理员',
    fail3: '清除用户数据失败，请联系管理员',
    btn: {
      back: '返回',
      next: '下一步',
      prev: '上一步',
      confirm: '确认',
      cancel: '取消',
      complete: '完成'
    }
  },
  notice: {
    head: '通知中心',
    unRead: '未读',
    read: '已读通知',
    readALL: '全部设为已读',
    empty: '暂无通知',
    latestNews: '最新通知',
    noMore: '没有更多的通知',
    warn: '获取消息列表失败',
    more: '了解更多',
    del: '删除',
    menu: {
      all: '所有通知'
    }
  },
  brandHKNew: {
    title: '全新香港号码',
    tips1: '新号首发，限量供应，没有使用记录。',
    tips2: '无SIM卡服务，App和微信收取短讯，App接听拨打电话。',
    tips3: 'App端单独购买的号码，不能在微信收取短信。',
    attention: '请注意',
    attentionTips1: '中国香港手机号需【实名认证】方可提供服务，根据当地法规需提供仍虚于有效期内的中国香港身份证/中国澳门身份证/港澳通行证/台胞证/护照等证件，中国内地居民身份证无法进行实名认证。请确认是否有以上证件.',
    attentionTips2: '本套餐香港号码，仅确保非循环使用的号 码以及只提供通信服务，不保证任何平台 或App 的注册是否成功.',
    attentionTips3: '如果因为个人问题无法完成实名，办理退款时将扣除HK$ 20 元号码占用费用.',
    btn1: '没有',
    btn2: '有',
    btn3: '不清楚',
    btn4: '清楚',
    number: {
      title: '选择心仪号码.....',
      content: '换一批号码',
      selectTip: '(只能换一次)',
      tip: '请先选择号码',
      warn: '获取可登记香港号码列表失败',
      tipTitle: '无法开通手机号',
      tipContent: '你的申请已达到上限，每个帐户最多可以申请 2 个中国香港手机号及 1 个中国内地手机号。',
      noNumberTips1: '全新香港手机号被抢光了!',
      noNumberTips2: '请联络我们的客服。'
    },
    member: {
      title: '香港免 SIM 卡服务',
      content: '香港特区政府于2021年6月1日公布订立《电讯（登记用户识别卡）规例》，并于同年9月1日实施，以落实电话智能卡实名登记制度，保障健全的电讯服务及通讯网络的安全，防止和协助侦查涉及使用电话储值卡的罪案。',
      userlabel: '客户资料',
      userTip: '输入姓名',
      userWarn: '请输入姓名',
      mobileTip: '输入联络电话',
      mobileWarn: '请输入正确的手机号码',
      codeLabel: '优惠码',
      codeTip: '优惠码（如有）',
      codeWarn: '请输入正确的优惠码',
      codeOk1: '成功使用，已额外获取 ',
      codeOk2: ' 天有效期',
      useCodeTip: '优惠码无效，是否继续购买?',
      useBut: '继续',
      cancleUseBut: '取消',
      mobilePrefixTitle: '选择电话区号',
      mobilePrefixList: [
        {name: '中国香港（+852）', value: '852'},
        {name: '中国内地（+86）', value: '86'},
        {name: '中国澳门（+853）', value: '853'},
        {name: '中国台湾（+886）', value: '886'},
        {name: '美国 / 加拿大（+1）', value: '1'},
        {name: '英国（+44）', value: '44'},
        {name: '马来西亚（+60）', value: '60'},
        {name: '澳洲（+61）', value: '61'},
        {name: '菲律宾（+63）', value: '63'},
        {name: '印尼（+62）', value: '62'},
        {name: '新加坡（+65）', value: '65'},
        {name: '泰国（+66）', value: '66'},
        {name: '日本（+81）', value: '81'},
        {name: '韩国（+82）', value: '82'},
        {name: '越南（+84）', value: '84'},
        {name: '法国（+33）', value: '33'},
        {name: '意大利（+39）', value: '39'},
        {name: '德国（+49）', value: '49'},
        {name: '其他', value: ''}
      ]
    },
    confirm: {
      title: '确认订单',
      tetle2: '香港免 SIM 卡服务',
      code: '优惠码',
      price: '总额',
      plan: '计划号码',
      username: '输入姓名',
      mobile: '联络电话',
      add: '加',
      day: '天有效期',
      update: '修改'
    },
    letter: {
      title: '「易博通」服务计划同意书（香港号码）',
      statement: '个人声明',
      statementInfo: '我已经阅读和了解广州博元讯息科技有限公司私隐政策及个人资料收集声明，第2条「收集个人资料」的规定，请在以下适当空格加上「√」号：',
      statementDetail1: '本人同意以上条款及细则。',
      statementDetail4: '本人同意博元使用本人的个人资料直接促销任何服务产品。',
      statementDetail2: '本人同意博元使用本人的个人资料，但仅限于延续服务安排及由博元直接提供的电讯服务 (包括但不限于流动语音，数据服务，国际漫游服务/长途电话服务产品促销资讯)。',
      statementDetail3: '本人不同意博元使用任何本人的个人资料促销用途。',
      content: [
        '以上服务提供于「易博通eSender」微信公众号及/或易博通APP绑定香港号码查阅及发送短讯服务。广州博元讯息科技有限公司 (「博元」) 亦可提供实体智能卡予客户携号转台或使用话音﹑数据及手机发送短讯服务，唯客户需要缴付智能卡费用及／或速递费用 (如适用)。话音﹑数据及手机发送短服务需另行收费。',
        '于易博通微信公众号及/或易博通APP发送短讯只提供予已选用套餐的户口，并需另行收费，费用会于户口内余额扣除，有关收费详情请浏览博元网页 www.multi-byte.com 或本公众号。',
        '当服务有效期届满前，博元将发送讯息予客户登记之香港号码提示客户，客户可于已于绑定香港号码的易博通微信公众号及/或易博通APP查阅，并可于效期届满前自行于易博通微信公众号﹑易博通APP或博元网页www.multi-byte.com 缴费以延长服务有效期。',
        '当服务有效期完结时，服务会被暂停。客户可于易博通微信公众号﹑易博通APP或博元网缴费并重启服务。暂停期间之讯息将不获补发。',
        '如服务因任何原故而停用超过 3 日或终止服务，客户同意届时必须放弃该分配的香港号码并归还予博元。',
        '服务计划中的香港号码不能更改。',
        '如服务因任何原故而停用，所预缴之费用将不获退还。',
        '任何优惠不得自由转让、退回现金及/ 或不可兑换其他服务及/ 或产品。',
        '根据香港《电讯 (登记用户识别卡) 规例》落实电话智能卡实名登记制度的实施安排，保障健全的电讯服务及通讯网络的安全，防止和协助侦查涉及使用电话储值卡的罪案。申请香港流动电话号码必须实名登记，个人用户须提供身分证明文件 (香港身份证或其他可接受的身分证明文件如旅客的“旅游证件”) 内的资料，包括姓名、出生日期和身分证明文件号码及其照片，以作登记。若公司或企业要登记成为电话智能卡用户，则须提供其商业登记资料及指定某人士作为代表或负责人，并提供该名人士的个人资料。16岁以下人士如需登记电话智能卡服务，相关登记必须得到一位成人的确认，电讯商亦会登记该名成人的资料。如阁下不提供个人资料，阁下将无法开通使用或继续使用涉及香港流动电话号码的电讯通讯服务，详情请浏览博元网页www.multi-byte.com。',
        '此服务受广州博元讯息科技有限公司的《一般条款及条件》约束，详情请浏览博元网页。',
        '上述资料为阁下自愿提供，如有资料错漏，博元讯息可能未能为阁下提供所申请之服务，博元讯息有权使用上述资料为阁下提供服务，通知阁下优惠推广活动，如有需要，披露予第三方作信用覆核﹑追讨债务﹑市场研究﹑及在法律规定下或遵从被认可之政府机关要求下披露及经阁下同意使用之其他用途。',
        '广州博元讯息科技有限公司保留更改本服务计划同意书之条款及条件与优惠之权利，恕不另行通知，遇有任何争议，概以博元之决定为最终决定，客户须受彼等约束。'
      ],
      warn: '请同意有关条款'
    }
  },
  polPlan: {
    title: '波兰手机号登记',
    registerErr: '预注册波兰号码失败',
    registerOk: '预注册波兰号码成功',
    plan: {
      title: '波兰手机号',
      content: '无 SIM 卡，微信和 App 收取短讯。',
      content2: 'App端单独购买的号码，不能在微信收取短信。',
      selectTip: '请选择你的计划.....',
      tip: '请先选择套餐',
      warn: '暂无套餐可供销售'
    },
    number: {
      title: '选择心仪号码.....',
      content: '换一批号码',
      selectTip: '(只能换一次)',
      tip: '请先选择号码',
      warn: '获取可登记波兰号码列表失败',
      tipTitle: '无法开通手机号',
      tipContent: '你的申请已达到上限，每个帐户最多可以申请 1 个波兰手机号。'
    },
    member: {
      title: '波兰手机号',
      content: '此波兰手机号套餐计划为无 SIM卡计划，计划只限于 APP或微信内收短讯使用。（计划并不包括通话、 发短讯和数据功能）',
      userlabel: '客户资料',
      userTip: '输入姓名',
      userWarn: '请输入姓名',
      mobileTip: '输入联络电话',
      mobileWarn: '请输入正确的手机号码',
      codeLabel: '优惠码',
      codeTip: '优惠码（如有）',
      codeTip2: '输入优惠码后， 在成功开通后可额外增加15日。',
      codeWarn: '请输入正确的优惠码',
      codeOk1: '成功使用，已额外获取 ',
      codeOk2: ' 天有效期',
      useCodeTip: '优惠码无效，是否继续购买?',
      useBut: '继续',
      cancleUseBut: '取消',
      mobilePrefixTitle: '选择电话区号',
      mobilePrefixList: [
        {name: '中国香港（+852）', value: '852'},
        {name: '中国内地（+86）', value: '86'},
        {name: '中国澳门（+853）', value: '853'},
        {name: '中国台湾（+886）', value: '886'},
        {name: '美国 / 加拿大（+1）', value: '1'},
        {name: '英国（+44）', value: '44'},
        {name: '马来西亚（+60）', value: '60'},
        {name: '澳洲（+61）', value: '61'},
        {name: '菲律宾（+63）', value: '63'},
        {name: '印尼（+62）', value: '62'},
        {name: '新加坡（+65）', value: '65'},
        {name: '泰国（+66）', value: '66'},
        {name: '日本（+81）', value: '81'},
        {name: '韩国（+82）', value: '82'},
        {name: '越南（+84）', value: '84'},
        {name: '法国（+33）', value: '33'},
        {name: '意大利（+39）', value: '39'},
        {name: '德国（+49）', value: '49'},
        {name: '其他', value: ''}
      ]
    },
    confirm: {
      title: '确认订单',
      tetle2: '波兰手机号',
      code: '优惠码',
      price: '总额',
      plan: '计划号码',
      username: '输入姓名',
      mobile: '联络电话',
      add: '加',
      day: '天有效期',
      update: '修改'
    },
    letter: {
      title: '「易博通香港eSender HK」服务计划同意书（波兰号码）',
      statement: '个人声明',
      statementInfo: '我已经阅读和了解广州博元讯息科技有限公司私隐政策及个人资料收集声明，第2条“收集个人资料”的规定，请在以下适当空格加上“√”号：',
      statementDetail1: '本人同意以上条款及细则。',
      statementDetail4: '本人同意博元使用本人的个人资料直接促销任何服务产品。',
      statementDetail2: '本人同意博元使用本人的个人资料，但仅限于延续服务安排及由博元直接提供的电讯服务 (包括但不限于流动语音，数据服务，国际漫游服务/长途电话服务产品促销资讯)。',
      statementDetail3: '本人不同意博元使用任何本人的个人资料促销用途。',
      content: [
        '以上服务提供于微信「易博通香港 eSender HK」公众号绑定波兰号码查阅短讯服务。',
        '当服务有效期届满前，博元将发送消息提示给予已登记波兰号码的客户，客户可于已于绑定波兰号码的微信「易博通香港eSenderHK」之公众号查阅，并可于有效期届满前自行在本公众号缴费以延长服务有效期。',
        '当服务有效期完结时，服务会被暂停。 客户可于微信易博通香港eSender HK公众号缴费并重启服务。 暂停期间之讯息将不会补发。',
        '如服务因任何原故而停用超过3日或终止服务，客户必须同意放弃该分配的波兰号码，并归还予博元。',
        '服务计划中嘅波兰号码将不能更改。',
        '如服务因任何原故而停用，所预缴之费用将不获退还。',
        '任何优惠不得自由转让、退回现金及/或不可兑换其他服务及/或产品。',
        '此服务受博元讯息科技有限公司的《一般条款及条件》约束，详情请浏览博元网页。 ',
        '上述资料为阁下自愿提供，如资料有错漏，博元讯息可能未能为阁下提供所申请之服务。 博元讯息有权使用上述资料为阁下提供服务或通知阁下优惠推广活动。 如有需要，将披露予第三方作信用复核、追讨债务、市场研究、及在法律规定下或遵从被认可之政府机关要求下披露及经阁下同意使用之其他用途。',
        '博元讯息科技有限公司保留更改本服务计划同意书之条款及条件与优惠之权利，恕不另行通知，如有任何争议，概以博元之决定为最终决定，客户须受彼等约束。'
      ],
      warn: '请同意有关条款'
    }
  },
  usPlan: {
    title: '美国手机号登记',
    registerErr: '预注册美国号码失败! 若您已申请但未支付，需等1小时后再试；若您无申请过，就需联系我们的客服。',
    registerOk: '预注册美国号码成功',
    plan: {
      title: '美国手机号',
      content: '无 SIM 卡，App 收取短讯。',
      content2: 'App端单独购买的号码，不能在微信收取短信。',
      selectTip: '请选择你的计划.....',
      tip: '请先选择套餐',
      warn: '暂无套餐可供销售'
    },
    member: {
      title: '美国手机号',
      content: '此美国手机号套餐计划为无 SIM卡计划，计划只限于 APP或微信内收短讯使用。（计划并不包括通话、 发短讯和数据功能）',
      userlabel: '客户资料',
      userTip: '输入姓名',
      userWarn: '请输入姓名',
      mobileTip: '输入联络电话',
      mobileWarn: '请输入正确的手机号码',
      codeLabel: '优惠码',
      codeTip: '优惠码（如有）',
      codeTip2: '输入优惠码后， 在成功开通后可额外增加15日。',
      codeWarn: '请输入正确的优惠码',
      codeOk1: '成功使用，已额外获取 ',
      codeOk2: ' 天有效期',
      useCodeTip: '优惠码无效，是否继续购买?',
      useBut: '继续',
      cancleUseBut: '取消',
      mobilePrefixTitle: '选择电话区号',
      mobilePrefixList: [
        {name: '中国香港（+852）', value: '852'},
        {name: '中国内地（+86）', value: '86'},
        {name: '中国澳门（+853）', value: '853'},
        {name: '中国台湾（+886）', value: '886'},
        {name: '美国 / 加拿大（+1）', value: '1'},
        {name: '英国（+44）', value: '44'},
        {name: '马来西亚（+60）', value: '60'},
        {name: '澳洲（+61）', value: '61'},
        {name: '菲律宾（+63）', value: '63'},
        {name: '印尼（+62）', value: '62'},
        {name: '新加坡（+65）', value: '65'},
        {name: '泰国（+66）', value: '66'},
        {name: '日本（+81）', value: '81'},
        {name: '韩国（+82）', value: '82'},
        {name: '越南（+84）', value: '84'},
        {name: '法国（+33）', value: '33'},
        {name: '意大利（+39）', value: '39'},
        {name: '德国（+49）', value: '49'},
        {name: '其他', value: ''}
      ],
      contactInfo: '联络信息',
      firstNameTip: 'First Name',
      firstNameWarn: '请输入First Name',
      lastNameTip: 'Lsst Name',
      lastNameWarn: '请输入Lsst Name',
      emailTip: '输入有效电邮地址',
      emailWarn: '输入有效电邮地址'
    },
    confirm: {
      title: '确认订单',
      title2: '美国手机号',
      code: '优惠码',
      price: '总额',
      plan: '计划号码',
      username: '输入姓名',
      mobile: '联络电话',
      add: '加',
      day: '天有效期',
      update: '修改',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email'
    },
    letter: {
      title: '「易博通eSender」服务计划同意书(美国号码）',
      statement: '个人声明',
      statementInfo: '我已经阅读及了解博元讯息科技有限公司私隐政策及个人资料收集声明，第2条“收集个人资料”的规定，请在以下适当空格加上【√】号：',
      statementDetail1: '本人同意以上条款及细则。',
      statementDetail4: '本人同意博元使用本人的个人资料直接促销任何服务产品。',
      statementDetail2: '本人同意博元使用本人的个人资料，但仅限于延续服务安排及由博元直接提供的电讯服务(包括但不限于流动语音，数据服务，国际漫游服务/长途电话服务产品促销资讯)。',
      statementDetail3: '本人不同意博元使用任何本人的个人资料促销用途。',
      content: [
        '以上服务提供于微信"易博通 eSender"公众号绑定美国号码查阅短讯服务。',
        '当服务有效期届满前，博元将发送讯息予客户登记之美国号码提示客户，客户可于已于绑定美国号码的微信"易博通香港eSenderHK"公众号查阅，并可于有效期届满前自行于本公众号缴费以延长服务有效期。',
        '当服务有效期完结时，服务会被暂停。客户可于微信"易博通 eSender "App缴费并重启服务。暂停期间之讯息将不获补发。',
        '如服务因任何原故而停用超过3日或终止服务，客户同意届时必须放弃该分配的英国号码并 归还予博元。',
        '服务计划中的美国号码不能更改。',
        '如服务因任何原故而停用，所预缴之费用将不获退还。',
        '任何优惠不得自由转让、退回现金及/或不可兑换其他服务及/或产品。',
        '此服务受博元讯息科技有限公司的《一般条款及条件》约束，详情请浏览博元网页。 ',
        '上述资料为阁下自愿提供，如有资料错漏，博元讯息可能未能为阁下提供所申请之服务，博元讯息有权使用上述资料为阁下提供服务，通知阁下优惠推广活动，如有需要，披露予第三方作信用覆核、追讨债务、市场研究、及在法律规定下或遵从被认可之政府机关要求下披露及经阁下同意使用之其他用途。',
        '博元讯息科技有限公司保留更改本服务计划同意书之条款及条件与优惠之权利，恕不另行通知，遇有任何争议，概以博元之决定为最终决定，客户须受彼等约束。'
      ],
      warn: '请同意有关条款'
    }
  },
  esContactUs: {
    head: '联络我们',
    onlineTitle: '在线客服',
    online1: '微信客服 eSender',
    online2: 'Facebook eSender',
    online3: 'WhatsApp',
    telTitle: '客户服务热线',
    tel1: '中国内地 (86) 400-888-4333',
    tel2: '中国香港 (852) 21568888',
    tel3: '俄罗斯 eSender.org',
    quesTitle: '常见问题',
    ques1: '有查询常见问题吗？你可能会从中得到答案。',
    quesBtn: '前往常见问题',
    sendTitle: '透过微信发送信息',
    send1: '如有任何疑问，可前往微信公众号与我们联络。',
    sendBtn: '前往微信公众号'
  },
  realNameInfo: {
    head: '实名资料查询',
    choosePhone: '选择号码',
    balance: '余额',
    authPass: '已实名认证',
    authFail: '未实名认证',
    auditing: '实名认证审核中',
    auditing2: '正在审核中',
    unAuth: '没有实名认证',
    unAuthStatus: '未实名认证，无法使用',
    numberInfo: '号码资料',
    noPhoneTips: '您当前没有号码，请先购买号码',
    status: '状态',
    normal: '正常',
    expired: '失效',
    active: '生效',
    numExpired: '过期',
    notRealName: '未实名',
    noNumber: '无号码',
    endDate: '到期日',
    notApplicable: '不适用',
    certNo: '证件号码',
    product: '产品属性',
    licenseNo: '许可编号',
    idType: '身份类型',
    realNameFlag: '实名制信息',
    customerLine: '客服电话',
    registerTime: '入网时间',
    mobile: '手机号码',
    operation: '运营商',
    customerName: '姓名',
    expiredTime: '到期时间',
    customerStatus: '用户状态',
    nodata: '未查询到资料',
    tips: '*仅限中国大陆号码资料查询'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn.js